import * as types from 'constants/actionTypes';
import moment from 'moment';
import LOOKUP from 'constants/lookup';

export default function FormReducer(state = {}, action) {
    switch (action.type) {
        case types.SET_BULK_TRANSFER_BRANCH_FROM: {
            return {
                ...state,
                bulkTransferBranchFrom: action.branchId,
            };
        }

        case types.SET_BULK_TRANSFER_BRANCH_TO: {
            return {
                ...state,
                bulkTransferBranchTo: action.branchId,
            };
        }
        // ACCOUNT
        case types.USER_FORGOTPASSWORD: {
            return {
                ...state,
                forgetPasswordSuccess: true,
                forgetPasswordSaveTimeStamp: new Date().toString()
            };
        }
        case types.FORGOTPASSWORD_USER_ERROR: {
            return {
                ...state,
                forgetPasswordSuccess: false,
                forgetPasswordSaveTimeStamp: new Date().toString()
            };
        }
        case types.CLEAR_FORGETPASSWORD_USER: {
            return {
                ...state,
                forgetPasswordSuccess: null,
                forgetPasswordSaveTimeStamp: null
            };
        }
        case types.LOGOUT_REQUEST:
        case types.INIT_LOGIN: {
            // if (process.env.NODE_ENV === 'development') {
            //     return { ...state, "userName": "techpos@techpos.com", "password": "P@ssw0rd!" };
            // }
            return {
                ...state,
                "userName": '',
                "password": ''
            };
        }
        case types.INIT_CHANGEPASSWORD_FORM: {
            return {
                ...state,
                changePasswordUserName: action.userName,
                changePasswordPassword: "",
                changePasswordNewPassword: "",
                error: null
            };
        }
        case types.USER_PASSWORD_CHANGED: {
            return {
                ...state,
                changePasswordSuccess: true,
                changePasswordSaveTimeStamp: new Date().toString()
            };
        }
        case types.CHANGE_USER_PASSWORD_ERROR: {
            return {
                ...state,
                changePasswordSuccess: false,
                changePasswordSaveTimeStamp: new Date().toString()
            };
        }
        case types.EMPLOYEE_PASSWORD_CHANGED: {
            return {
                ...state,
                employeePasswordChangeSuccess: true,
                employeePasswordChangeSaveTimeStamp: new Date().toString()
            };
        }
        case types.CHANGE_EMPLOYEE_PASSWORD_ERROR: {
            return {
                ...state,
                employeePasswordChangeSuccess: false,
                employeePasswordChangeSaveTimeStamp: new Date().toString()
            };
        }
        case types.CLEAR_EMPLOYEECHANGEPASSWORD_FORM: {
            return {
                ...state,
                employeePassword: "",
                employeePasswordConfirm: "",
            };
        }
        case types.USER_PASSWORDRESET: {
            return {
                ...state,
                employeePasswordResetSuccess: true,
                employeePasswordResetTimeStamp: new Date().toString()
            };
        }
        case types.RESETPASSWORD_USER_ERROR: {
            return {
                ...state,
                employeePasswordResetSuccess: false,
                employeePasswordResetTimeStamp: new Date().toString()
            };
        }
        case types.CLEAR_RESETPASSWORD_USER: {
            return {
                ...state,
                employeePasswordResetSuccess: false,
                employeePasswordResetTimeStamp: null
            };
        }
        // FORM
        case types.FORM_INPUT:
            return { ...state, [action.name]: action.value };
        case types.CLEAR_FORM_INPUT: {
            const newState = { ...state, [action.name]: null };
            return newState;
        }
        case types.FORM_ERROR:
            return {
                ...state, error: {
                    ...state.error, [action.name]: action.error
                }
            };
        case types.CLEAR_FORM_ERRORS:
            return {
                ...state,
                error: null
            }
        case types.VALIDATE:
            return {
                ...state, validator: action.validate
            };
        // PRODUCT
        case types.PRODUCT_GOT: {

            return {
                ...state,
                error: null,
                [action.compName + "Id"]: action.product.id.toString(),
                [action.compName + "SKU"]: action.product.sku,
                [action.compName + "UPC"]: action.product.upc,
                [action.compName + "isCannabis"]: action.product.isCannabis,
                [action.compName + "categoryName"]: action.product.category,
                [action.compName + "categoryId"]: action.product.categoryId,
                [action.compName + "Name"]: action.product.name,
                [action.compName + "Type"]: action.product.type,
                [action.compName + "UnitPrice"]: action.product.unitPrice.toFixed(2),
                [action.compName + "PromotionUnitPrice"]: action.product.promotionUnitPrice.toFixed(2),
                [action.compName + "MemberUnitPrice"]: action.product.memberUnitPrice.toFixed(2),
                [action.compName + "EliteMemberUnitPrice"]: action.product.eliteMemberUnitPrice.toFixed(2),
                [action.compName + "IsElite"]: action.product.isElite,
                [action.compName + "TypeId"]: action.product.typeId,
                [action.compName + "CategoryId"]: action.product.categoryId,
                [action.compName + "PriceMatrixId"]: action.product.priceMatrixId,
                [action.compName + "Status"]: action.product.status === 'Active' ? true : false,
                [action.compName + "ImageURL"]: action.product.urlImage,
                [action.compName + "WeightPerUnit"]: action.product.weightPerUnit !== null ? action.product.weightPerUnit.toFixed(2) : null,
                [action.compName + "BaseCost"]: action.product.baseCost.toFixed(2),
                [action.compName + "LatestBaseCost"]: action.product.latestBaseCost.toFixed(2),
                [action.compName + "Description"]: action.product.description,
                [action.compName + "BarCode"]: action.product.barCode,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "CannabisSpecies"]: action.product.cannabisSpecies,
                [action.compName + "legalBarCode"]: action.product.legalBarCode,
                [action.compName + "DepositEnabled"]: action.product.depositEnabled,
                [action.compName + "DepositAmount"]: action.product.depositAmount == null ? 0.00 : action.product.depositAmount.toFixed(2),
                [action.compName + "dfe"]: action.product.dfe == null ? 0.00 : action.product.dfe.toFixed(2),
                [action.compName + "WebmenuDisplayEnabled"]: action.product.webMenuDisplayed,
                [action.compName + "Brand"]: action.product.brand,
                [action.compName + "THC"]: action.product.thc != null ? action.product.thc.toFixed(2) : "",
                [action.compName + "CBD"]: action.product.cbd != null ? action.product.cbd.toFixed(2) : "",
                [action.compName + "THCMin"]: action.product.thC_MIN != null ? action.product.thC_MIN.toFixed(2) : "",
                [action.compName + "THCMax"]: action.product.thC_MAX != null ? action.product.thC_MAX.toFixed(2) : "",
                [action.compName + "CBDMin"]: action.product.cbD_MIN != null ? action.product.cbD_MIN.toFixed(2) : "",
                [action.compName + "CBDMax"]: action.product.cbD_MAX != null ? action.product.cbD_MAX.toFixed(2) : "",
                [action.compName + "UOM"]: action.product.uom,
                productGotSuccessKey: new Date().getTime(),
                [action.compName + "WebName"]: action.product.webName,
                [action.compName + "SubCategoryName"]: action.product.subCategoryName,
                [action.compName + "Size"]: action.product.size,
                [action.compName + "ProvinceCode"]: action.product.provinceCode,
                productSupplier: action.product.productSupplier
            };
        }
        case types.INITIALIZE_STORE_PRODUCT: {
            const copyState = {
                ...state,
                [action.compName + "Id"]: "",
                [action.compName + "SKU"]: "",
                [action.compName + "Name"]: "",
                [action.compName + "Type"]: "",
                [action.compName + "UnitPrice"]: "",
                [action.compName + "MemberUnitPrice"]: "",
                [action.compName + "PromotionUnitPrice"]: "",
                [action.compName + "EliteMemberUnitPrice"]: "",
                [action.compName + "CategoryId"]: "",
                [action.compName + "TypeId"]: "",
                [action.compName + "PriceMatrixId"]: "",
                [action.compName + "Status"]: true,
                [action.compName + "WeightPerUnit"]: null,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "ImageURL"]: "",
                [action.compName + "Description"]: "",
                [action.compName + "DescriptionAdd"]: "",
                [action.compName + "BarCode"]: "",
                [action.compName + "WebmenuDisplayEnabled"]: true,
                [action.compName + "IsElite"]: false,
                [action.compName + "dfe"]: "",
                [action.compName + "Brand"]: "",
                [action.compName + "THC"]: "",
                [action.compName + "CBD"]: "",
                [action.compName + "THCMin"]: "",
                [action.compName + "THCMax"]: "",
                [action.compName + "CBDMin"]: "",
                [action.compName + "CBDMax"]: "",
                error: null
            };

            for (let name in copyState) {
                if (copyState.hasOwnProperty(name) && name.indexOf(action.compName + "PriceMatrixTableDetails") !== -1) {
                    delete copyState[name];
                }
            }

            return {
                ...copyState
            };
        }
        case types.INITIALIZE_STORE_PRODUCT_CHANGE_TYPE: {
            const copyState = {
                ...state,
                [action.compName + "UnitPrice"]: "",
                [action.compName + "MemberUnitPrice"]: "",
                [action.compName + "PriceMatrixId"]: "",
                error: null
            };

            for (let name in copyState) {
                if (copyState.hasOwnProperty(name) && name.indexOf(action.compName + "PriceMatrixTableDetails") !== -1) {
                    delete copyState[name];
                }
            }

            return {
                ...copyState
            };
        }
        case types.LOAD_PRODUCT_PRICE_MATRIX_TABLE: {
            let details = {};
            let copyState = {
                ...state
            };

            for (let name in copyState) {
                if (copyState.hasOwnProperty(name) && name.indexOf(action.compName + "Details") !== -1) {
                    delete copyState[name];
                }
            }
            action.priceMatrix && action.priceMatrix.priceMatrixDetails.map((item) => {
                details[`${action.compName}DetailsPrice${item.weightSettingId}`] = item.price.toFixed(2);
                details[`${action.compName}DetailsMemberPrice${item.weightSettingId}`] = item.memberPrice.toFixed(2);
                details[`${action.compName}DetailsIsCampaign_${item.weightSettingId}`] = item.isCampaign;
            });
            return {
                ...copyState,
                ...details
            };
        }
        case types.INITIALIZED_STORE_PRODUCT:
            return { ...state, options: action.value.types };
        case types.INITIALIZE_STORE_PRODUCT_FAILED:
            return state;
        case types.PRODUCT_CREATED:
            return {
                ...state,
                [action.compName + "SaveSuccess"]: true
            };
        case types.PRODUCT_CREATE_FAILED:
            return {
                ...state,
                [action.compName + "SaveSuccess"]: false
            };

        case types.DELETE_PRODUCT_SUCCESS:
            return {
                ...state,
                ["productdelete" + "SaveSuccess"]: true
            }
        case types.INVENTORY_ADJUST_ROUND_PRICES_SUCCESS:
            return {
                ...state,
                ['inventoryAdjustRoundPriceSuccess']: true
            };
        case types.BULK_UPDATE_MEMBER_PRICE_SUCCESS:
            return {
                ...state,
                ['bulkupdateMemberPriceSuccessTimeStamp']: new Date().toLocaleString()
            }
        // PATIENT
        case types.INITIALIZE_STORE_PATIENT: {
            let patientData = { ...state };

            //delete data from medical information from state.form and leave all others attributtes (setting it to '')
            for (let name in patientData) {
                if (patientData.hasOwnProperty(name) && name.indexOf(action.compName) !== -1) {
                    if (name.indexOf(action.compName + "Doctor") !== -1 || name.indexOf(action.compName + "Notes") !== -1) {
                        delete patientData[name];
                    }
                    else {
                        if (Array.isArray(patientData[name]))
                            patientData[name] = [];
                        else
                            patientData[name] = null;
                    }
                }
            }

            let oneYearFromNow = new Date();
            oneYearFromNow.setFullYear(new Date().getFullYear() + 1);

            return {
                ...patientData,
                [action.compName + "Status"]: true,
                [action.compName + "PreferredMethodEmail"]: true,
                [action.compName + "PreferredMethodPhone"]: true,
                [action.compName + "PreferredMethodSms"]: true,
                [action.compName + "Gender"]: 'Other',
                [action.compName + "IsMember"]: true,
                [action.compName + "DownloadPhotoUrl"]: '',
                [action.compName + "MemberSince"]: new Date(),
                error: null
            };
        }
        case types.PATIENT_FORM_LOADED: {
            const patientDefaultFields = {
                [action.compName + "Id"]: action.data.id.toString(),
                [action.compName + "Status"]: action.data.status === "Active" ? true : false,
                [action.compName + "Phone"]: action.data.phone,
                [action.compName + "Email"]: action.data.email,
                [action.compName + "PreferredName"]: action.data.preferredName,
                [action.compName + "AdditionalInformation"]: action.data.additionalInformation,
                [action.compName + "PreferredMethodEmail"]: action.data.contactMethodsTypes.indexOf('Email') !== -1,
                [action.compName + "PreferredMethodPhone"]: action.data.contactMethodsTypes.indexOf('Phone') !== -1,
                [action.compName + "PreferredMethodSms"]: action.data.contactMethodsTypes.indexOf('SMS') !== -1,
                [action.compName + "MemberSince"]: action.data.memberSince,
                [action.compName + "Birthdate"]: action.data.dateOfBirth,
                [action.compName + "Gender"]: action.data.gender,
                [action.compName + "IdentificationType"]: action.data.identificationType == 0 ? null : action.data.identificationType,
                [action.compName + "IdentificationNumber"]: action.data.identificationNumber,
                [action.compName + "FirstName"]: action.data.firstName,
                [action.compName + "LastName"]: action.data.lastName,
                [action.compName + "CareGiver"]: action.data.careGiver,
                [action.compName + "Address"]: action.data.address,
                [action.compName + "Country"]: action.data.country,
                [action.compName + "ProvinceState"]: action.data.state,
                [action.compName + "City"]: action.data.city,
                [action.compName + "PostalCode"]: action.data.postalCode,
                [action.compName + "Photo"]: action.data.photo,
                [action.compName + "IsMember"]: action.data.isMember,
                [action.compName + "DownloadPhotoUrl"]: action.data.downloadPhotoUrl,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                [action.compName + "RewardPoint"]: action.data.rewardPoints,
                [action.compName + "CardNumber"]: action.data.cardNumber,
                [action.compName + "OnlineUserSignedUp"]: action.data.onlineUserSignedUp || false,
                [action.compName + "OnlineUserLockedOut"]: action.data.onlineUserAccountLockedOut || false,
                [action.compName + "sbOptInSpringBig"]: action.data.sbOptInSpringBig || false,
                [action.compName + "sbOptInTechPos"]: action.data.sbOptInTechPos || false,
                [action.compName + "sbPatientExists"]: action.data.sbPatientExists || false
            };

            return {
                ...state,
                ...patientDefaultFields
            };
        }
        case types.PATIENT_ACCOUNT_UNLOCKED:
            return {
                ...state,
                [action.compName + "OnlineUserLockedOut"]: action.onlineUserLockedOut
            };
        case types.PATIENT_SAVED:
            return {
                ...state, [action.compName + "SaveSuccess"]: true,
                [action.compName + "SaveError"]: null,
                [action.compName + "NewId"]: action.data.id.toString(),
                ["POSPatientPatient"]: action.data
            };
        case types.MERMBER_MERGE_SUCCESS:
            return {
                ...state, ["MemberMergeSuccess"]: true
            };
        case types.PATIENT_SAVE_FAILED:
            return {
                ...state,
                [action.compName + "SaveSuccess"]: false,
                [action.compName + "SaveError"]: (action.error + " - " + (new Date().toLocaleString()))
            };
        case types.GET_PRODUCT_CATEGORY_ERROR:
        case types.CLEAR_PRODUCT_CATEGORY_FORM: {
            const copyState = {
                ...state,
                [action.compName + "Name"]: '',
                [action.compName + "TypeId"]: '',
                [action.compName + "IsCannabis"]: false,
                [action.compName + "IsRefundable"]: false,
                [action.compName + "Status"]: true,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                [action.compName + "ClassOfCannabisText"]: '',
                [action.compName + "ClassOfCannabis"]: 0
            };

            for (let name in copyState) {
                if (copyState.hasOwnProperty(name) && name.indexOf(action.compName + "TaxRate-") !== -1) {
                    delete copyState[name];
                }
            }

            return {
                ...copyState
            };
        }
        case types.GET_PRODUCT_CATEGORY_SUCCESS: {
            let taxesRates = {};
            // Use productCategoryTaxRates for province tax and province selections
            const productCategoryTaxRates = action.data.productCategoryTaxRates || [];
            productCategoryTaxRates.forEach(taxRate => {
                // Always check the main tax checkbox
                taxesRates[action.compName + "TaxRate-" + taxRate.taxRateId] = true;
            });

            // Province tax mode and province selections
            let taxProvinceMode = {};
            let taxProvinceSelections = {};

            productCategoryTaxRates.forEach(taxRate => {
                // Province Tax toggle
                if (taxRate.isProvinceTax) {
                    taxProvinceMode[action.compName + "TaxProvinceMode-" + taxRate.taxRateId] = true;
                }
                // Province selections
                if (taxRate.provinceToUse && typeof taxRate.provinceToUse === "string") {
                    const provinceCodes = taxRate.provinceToUse.split(",").map(x => parseInt(x.trim())).filter(x => !isNaN(x));
                    if (provinceCodes.length > 0) {
                        taxProvinceSelections[action.compName + "TaxProvinceSelections-" + taxRate.taxRateId] = provinceCodes;
                    }
                }
            });

            const copyState = {
                ...state,
                [action.compName + "Id"]: action.data.id,
                [action.compName + "Name"]: action.data.name,
                [action.compName + "TypeId"]: action.data.typeId,
                [action.compName + "IsCannabis"]: action.data.isCannabis,
                [action.compName + "IsRefundable"]: action.data.isRefundable,
                [action.compName + "Status"]: action.data.status === "Active" ? true : false,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                [action.compName + "ClassOfCannabisText"]: action.data.classOfCannabis,
                [action.compName + "ClassOfCannabis"]: action.data.classOfCannabisId,
                [action.compName + "BCCannabisClass"]: action.data.bcCannabisClass,
                [action.compName + "UnitOfMeasurement"]: action.data.unitOfMeasurement,
                [action.compName + "priceMargin"]: action.data.priceMargin ? action.data.priceMargin.toFixed(2) : 0
            };

            for (let name in copyState) {
                if (copyState.hasOwnProperty(name) && name.indexOf(action.compName + "TaxRate-") !== -1) {
                    delete copyState[name];
                }
            }

            return {
                ...copyState,
                ...taxesRates,
                ...taxProvinceMode,
                ...taxProvinceSelections
            };
        }
        case types.SAVE_PRODUCT_CATEGORY_SUCCESS: {
            return {
                ...state,
                [action.compName + "SaveSuccess"]: true,
                [action.compName + "SaveError"]: null
            };
        }
        case types.SAVE_PRODUCT_CATEGORY_ERROR: {
            return {
                ...state,
                [action.compName + "SaveSuccess"]: false,
                [action.compName + "SaveError"]: (action.error + " - " + (new Date().toLocaleString()))
            };
        }
        //MEDICAL INFORMATION
        case types.FORM_MEDICAL_INFORMATION_ADD:
            return {
                ...state,
                [action.compName + "MedicalInformations"]: [...state[action.compName + "MedicalInformations"], { ...action.value }]
            };
        case types.FORM_MEDICAL_INFORMATION_REMOVE: {
            let newState = {
                ...state,
                [action.compName + "MedicalInformations"]: action.value
            };

            delete newState[action.compName + "Doctor" + action.index];
            delete newState[action.compName + "Notes" + action.index];

            return {
                ...newState
            };
        }
        case types.FORM_MEDICAL_INFORMATION_INPUT: {
            return {
                ...state,
                [action.compName + "MedicalInformations"]: action.value
            };
        }
        case types.INITIALIZE_STORE_MEDICAL_INFORMATION:
            return {
                ...state,
                [action.compName + "MedicalInformations"]: [{ doctor: '', notes: '' }]
            };

        // BANK DEPOSIT
        case types.BANKDEPOSITS_INITIALIZE_STORE:
            return {
                ...state,
                [action.compName + "Id"]: 0,
                [action.compName + "DepositDate"]: new Date(),
                [action.compName + "Amount"]: 0,
                [action.compName + "Tips"]: 0,
                [action.compName + "CoinOrder"]: 0,
                [action.compName + "ReferenceCode"]: "",
                [action.compName + "Notes"]: "",
                [action.compName + "User"]: "",
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null
            };
        case types.BANKDEPOSITS_GOT: {
            let deposit = action.response;
            return {
                ...state,
                [action.compName + "Id"]: deposit.id,
                [action.compName + "DepositDate"]: deposit.depositDate,
                [action.compName + "Amount"]: deposit.amount,
                [action.compName + "CoinOrder"]: deposit.coinOrder,
                [action.compName + "Tips"]: deposit.tips,
                [action.compName + "ReferenceCode"]: deposit.referenceCode,
                [action.compName + "Notes"]: deposit.notes,
                [action.compName + "User"]: deposit.logUserName,
                [action.compName + "SaveSuccess"]: false,
                [action.compName + "SaveError"]: false
            };
        }
        case types.BANKDEPOSITS_SAVED:
            return {
                ...state,
                error: null,
                [action.compName + "SaveSuccess"]: true,
                [action.compName + "SaveError"]: false
            };
        case types.BANKDEPOSITS_SAVED_ERROR:
            return {
                ...state,
                error: action.error,
                [action.compName + "SaveError"]: true,
                [action.compName + "SaveSuccess"]: false
            };

        // SAFE MANAGEMENT
        case types.SAFEMANAGEMENT_SAVED:
            return {
                ...state,
                [action.compName + "SaveSuccess"]: true,
                [action.compName + "SaveError"]: false
            };

        case types.SAFEMANAGEMENT_SAVED_ERROR:
            return {
                ...state,
                [action.compName + "SaveSuccess"]: false,
                [action.compName + "SaveError"]: action.error
            };

        // VENDOR
        case types.INITIALIZE_STORE_VENDOR:
            return {
                ...state,
                [action.compName + "Id"]: "",
                [action.compName + "Name"]: "",
                [action.compName + "LicenseNumber"]: "",
                [action.compName + "CategoryId"]: "",
                [action.compName + "Website"]: "",
                [action.compName + "Address"]: "",
                [action.compName + "Country"]: "",
                [action.compName + "CountryText"]: "",
                [action.compName + "ProvinceState"]: "",
                [action.compName + "ProvinceStateText"]: "",
                [action.compName + "City"]: "",
                [action.compName + "PostalCode"]: "",
                [action.compName + "Phone"]: "",
                [action.compName + "Email"]: "",
                [action.compName + "Contact"]: "",
                [action.compName + "Status"]: true,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                [action.compName + "Categories"]: [
                    {
                        text: "Grower",
                        value: 1
                    },
                    {
                        text: "Accessories",
                        value: 2
                    }
                ],
                error: null
            };
        case types.VENDOR_GOT:
            return {
                ...state,
                [action.compName + "Id"]: action.vendor.id.toString(),
                [action.compName + "Name"]: action.vendor.name,
                [action.compName + "LicenseNumber"]: action.vendor.licenseNumber,
                [action.compName + "CategoryId"]: action.vendor.categoryID,
                [action.compName + "Website"]: action.vendor.website,
                [action.compName + "Address"]: action.vendor.address,
                [action.compName + "Country"]: action.vendor.country,
                [action.compName + "CountryText"]: "",
                [action.compName + "State"]: action.vendor.state,
                [action.compName + "StateText"]: "",
                [action.compName + "City"]: action.vendor.city,
                [action.compName + "PostalCode"]: action.vendor.postalCode,
                [action.compName + "Phone"]: action.vendor.phone,
                [action.compName + "Email"]: action.vendor.email,
                [action.compName + "Contact"]: action.vendor.contact,
                [action.compName + "Status"]: action.vendor.status === "Active" ? true : false,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                [action.compName + "Categories"]: [
                    {
                        text: "Grower",
                        value: 1
                    },
                    {
                        text: "Accessories",
                        value: 2
                    }
                ]
            };
        case types.VENDOR_SAVED:
            return {
                ...state, [action.compName + "SaveSuccess"]: true
            };
        case types.VENDOR_SAVED_FAILED:
            return {
                ...state,
                [action.compName + "SaveSuccess"]: false
            };
        // DOCTOR
        case types.INITIALIZE_STORE_DOCTOR:
            return {
                ...state,
                [action.compName + "Id"]: "",
                [action.compName + "FirstName"]: "",
                [action.compName + "LastName"]: "",
                [action.compName + "License"]: "",
                [action.compName + "Clinic"]: "",
                [action.compName + "Phone"]: "",
                [action.compName + "Address"]: "",
                [action.compName + "PostalCode"]: "",
                [action.compName + "Country"]: "",
                [action.compName + "ProvinceState"]: "",
                [action.compName + "City"]: "",
                [action.compName + "Status"]: true,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                error: null
            };
        case types.DOCTOR_CREATED:
        case types.DOCTOR_EDITED:
            return {
                ...state, [action.compName + "SaveSuccess"]: true,
                [action.compName + "SaveError"]: null
            };
        case types.DOCTOR_SAVE_FAILED:
            return {
                ...state, [action.compName + "SaveSuccess"]: false,
                [action.compName + "SaveError"]: (action.error + " - " + (new Date().toLocaleString()))
            };
        case types.DOCTOR_EDIT_LOADED: {
            return {
                ...state,
                [action.compName + "Id"]: action.data.id.toString(),
                [action.compName + "FirstName"]: action.data.firstName,
                [action.compName + "LastName"]: action.data.lastName,
                [action.compName + "License"]: action.data.license,
                [action.compName + "Clinic"]: action.data.clinic,
                [action.compName + "Phone"]: action.data.phone,
                [action.compName + "Address"]: action.data.address,
                [action.compName + "PostalCode"]: action.data.zip,
                [action.compName + "Country"]: action.data.country,
                [action.compName + "ProvinceState"]: action.data.state,
                [action.compName + "City"]: action.data.city,
                [action.compName + "Status"]: action.data.status == "Active" ? true : false,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null
            };
        }
        // EMPLOYEE
        case types.INITIALIZE_STORE_EMPLOYEE: {
            const copyState = {
                ...state,
                [action.compName + "Id"]: '',
                [action.compName + "Status"]: true,
                [action.compName + "Role"]: '',
                [action.compName + "FirstName"]: '',
                [action.compName + "LastName"]: '',
                [action.compName + "Email"]: '',
                [action.compName + "Phone"]: '',
                [action.compName + "Birthdate"]: '',
                [action.compName + "Address"]: '',
                [action.compName + "Country"]: '',
                [action.compName + "ProvinceState"]: '',
                [action.compName + "City"]: '',
                [action.compName + "PostalCode"]: '',
                [action.compName + "Password"]: '',
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                [action.compName + "Branch-" + action.branchId]: true,
                [action.compName + "AccountLockedOut"]: false,
                //[action.compName + "SaveError"]: null,
                error: null
            };

            return {
                ...copyState
            };
        }
        case types.EMPLOYEE_GOT: {
            let branchesInfo = {};
            action.employee.branches.forEach(item => {
                branchesInfo[`${action.compName}Branch-${item}`] = true;
            });

            const copyState = {
                ...state
            };

            for (let name in copyState) {
                if (copyState.hasOwnProperty(name) && name.indexOf(action.compName + "Branch-") !== -1) {
                    delete copyState[name];
                }
            }

            return {
                ...copyState,
                [action.compName + "Id"]: action.employee.id.toString(),
                [action.compName + "Status"]: action.employee.status == 'Active' ? true : false,
                [action.compName + "FirstName"]: action.employee.firstName,
                [action.compName + "LastName"]: action.employee.lastName,
                [action.compName + "Role"]: action.employee.role,
                [action.compName + "Email"]: action.employee.email,
                [action.compName + "Phone"]: action.employee.phone,
                [action.compName + "Birthdate"]: action.employee.dateOfBirth,
                [action.compName + "Address"]: action.employee.address,
                [action.compName + "Country"]: action.employee.country,
                [action.compName + "ProvinceState"]: action.employee.state,
                [action.compName + "City"]: action.employee.city,
                [action.compName + "PostalCode"]: action.employee.postalCode,
                [action.compName + "Pin"]: action.employee.pinPassword,
                [action.compName + "SIN"]: action.employee.sin,
                [action.compName + "HiredDate"]: action.employee.hiredDate,
                [action.compName + "HourlyRate"]: action.employee.hourlyRate ? action.employee.hourlyRate.toFixed(2).toString() : 0,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                [action.compName + "AccountLockedOut"]: action.employee.accountLockedOut || false,
                ...branchesInfo
            };
        }

        case types.EMPLOYEE_SAVED: {
            return {
                ...state,
                [action.compName + "SaveSuccess"]: true
            };
        }
        case types.EMPLOYEE_SAVE_FAILED: {
            return {
                ...state,
                [action.compName + "SaveSuccess"]: false,
                [action.compName + "SaveError"]: (action.error + " - " + (new Date().toLocaleString()))
            };
        }
        // PURCHASE ORDER
        case types.LOAD_PO_PRODUCT: {
            const product = action.productList.filter(i => i.id == action.productId)[0];
            const { id = 0, category = "", type = "", name = "", sku = ""} = product || {};

            return {
                ...state,
                [action.compName + "Id"]: +id,
                [action.compName + "Category"]: category,
                [action.compName + "Type"]: type,
                [action.compName + "Name"]: name,
                [action.compName + "Sku"]: sku
            };
        }
        case types.INITIALIZE_STORE_PO_PRODUCT:
            return {
                ...state,
                [action.compName + "Id"]: "",
                [action.compName + "IdText"]: "",
                [action.compName + "Type"]: "",
                [action.compName + "Category"]: "",
                [action.compName + "Quantity"]: "",
                [action.compName + "Price"]: "",
                [action.compName + "Status"]: false,
                [action.compName + "UnitPrice"]: "",
                error: null
            };
        case types.PURCHASE_FORM_LOADED: {
            return {
                ...state,
                [action.compName + "Id"]: action.purchaseOrder.id.toString(),
                [action.compName + "Name"]: action.purchaseOrder.description,
                [action.compName + "VendorID"]: action.purchaseOrder.vendorId,
                [action.compName + "Tax"]: action.purchaseOrder.tax,
                [action.compName + "PaymentDueDate"]: action.purchaseOrder.paymentDueDate,
                [action.compName + "DateExpected"]: action.purchaseOrder.dateExpected,
                [action.compName + "Status"]: action.purchaseOrder.status,
                [action.compName + "UpdateStatusSuccess"]: null,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                [action.compName + "DeliveryFee"]: action.purchaseOrder.deliveryFee ? action.purchaseOrder.deliveryFee.toFixed(2).toString() : 0,
                [action.compName + "RecycleFee"]: action.purchaseOrder.recycleFee ? action.purchaseOrder.recycleFee.toFixed(2).toString() : 0,
                [action.compName + "TotalDepositAmount"]: action.purchaseOrder.totalDepositAmount ? action.purchaseOrder.totalDepositAmount.toFixed(2).toString() : 0,
                [action.compName + "Credits"]: action.purchaseOrder.credits ? action.purchaseOrder.credits.toFixed(2).toString() : 0,
                [action.compName + "GST"]: action.purchaseOrder.taxes ? action.purchaseOrder.taxes.filter(x => x.name == "GST").length > 0 ? action.purchaseOrder.taxes.filter(x => x.name == "GST")[0].amount.toFixed(2).toString() : 0 : 0,
                [action.compName + "PST"]: action.purchaseOrder.taxes ? action.purchaseOrder.taxes.filter(x => x.name == "PST").length > 0 ? action.purchaseOrder.taxes.filter(x => x.name == "PST")[0].amount.toFixed(2).toString() : 0 : 0,
                [action.compName + "HST"]: action.purchaseOrder.taxes ? action.purchaseOrder.taxes.filter(x => x.name == "HST").length > 0 ? action.purchaseOrder.taxes.filter(x => x.name == "HST")[0].amount.toFixed(2).toString() : 0 : 0,
                [action.compName + "QST"]: action.purchaseOrder.taxes ? action.purchaseOrder.taxes.filter(x => x.name == "QST").length > 0 ? action.purchaseOrder.taxes.filter(x => x.name == "QST")[0].amount.toFixed(2).toString() : 0 : 0,
                [action.compName + "POTotal"]: action.purchaseOrder.total.toFixed(2).toString(),
                [action.compName + "POSubtotal"]: action.purchaseOrder.subTotal.toFixed(2).toString(),
                [action.compName + "SupplierInvoiceNumber"]: action.purchaseOrder.supplierInvoiceNumber
            };
        }
        case types.INITIALIZE_STORE_PURCHASEORDER:
            const taxes = Object.keys(state)
                .filter(k => k.includes(`${action.compName}TAX`))
                .map(k => {
                    return {
                        [k]: 0
                    }
                });
            console.log(taxes, "CLEANING INPUT");

            //TODO - Clean Taxes
            return {
                ...state,
                [action.compName + "Name"]: "",
                [action.compName + "VendorID"]: "",
                [action.compName + "Tax"]: "",
                [action.compName + "PaymentDueDate"]: "",
                [action.compName + "DateExpected"]: "",
                [action.compName + "UpdateStatusSuccess"]: null,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                [action.compName + "Total"]: 0,
                [action.compName + "SubTotal"]: 0,
                [action.compName + "DeliveryFee"]: 0,
                [action.compName + "RecycleFee"]: 0,
                [action.compName + "TotalDepositAmount"]: 0,
                [action.compName + "Credits"]: 0,
                [action.compName + "GST"]: 0,
                [action.compName + "HST"]: 0,
                [action.compName + "PST"]: 0,
                [action.compName + "QST"]: 0,
                error: null
            };
        case types.PURCHASE_ORDER_CREATED:
        case types.PURCHASE_ORDER_EDITED:
            return {
                ...state, [action.compName + "SaveSuccess"]: true,
                [action.compName + "SaveError"]: null
            };
        case types.PURCHASE_ORDER_SAVE_ERROR:
            return {
                ...state, [action.compName + "SaveSuccess"]: false,
                [action.compName + "SaveError"]: (action.error + " - " + (new Date().toLocaleString()))
            };
        case types.PO_STATUS_SAVE_FAILED:
            return {
                ...state, [action.compName + "UpdateStatusSuccess"]: false
            };
        case types.PRODUCT_PO_RECEIVE_FAILED:
            return {
                ...state, receiveProductPOSaveSuccess: false
            };
        case types.PRODUCT_PO_RECEIVED:
            return {
                ...state, receiveProductPOSaveSuccess: true, receiveProductPOSaveSuccessKey: new Date().getTime()
            };
        case types.PRODUCTS_IN_TRANSIT_LOADED:
        case types.INITIALIZE_STORE_RECEIVE_PURCHASEORDER:
            return {
                ...state, receiveProductPOSaveSuccess: null
            };
        case types.CLEAN_COMPONENTS_TABLE:
            return {
                ...state,
                [action.parentCompName + action.childCompName + "Amount"]: "",
                [action.parentCompName + action.childCompName + "ToWarehouse"]: "",
                [action.parentCompName + "SelectedJointProduct"]: ""
            };
        // WEIGHT SETTINGS
        case types.INITIALIZE_STORE_WEIGHT_SETTING: {
            return {
                ...state,
                [action.compName + "Id"]: "",
                [action.compName + "Name"]: "",
                [action.compName + "Weight"]: "",
                [action.compName + "Measurement"]: "",
                [action.compName + "UnitOfMeasurement"]: "",
                [action.compName + "Status"]: true,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null,
                error: null
            };
        }
        case types.WEIGHT_SETTING_GOT: {
            return {
                ...state,
                [action.compName + "Id"]: action.weightSetting.id.toString(),
                [action.compName + "Name"]: action.weightSetting.name,
                [action.compName + "Measurement"]: action.weightSetting.weight.toFixed(1).toString(),
                [action.compName + "Status"]: action.weightSetting.status === 'Active' ? true : false,
                [action.compName + "SaveSuccess"]: null,
                [action.compName + "SaveError"]: null
            };
        }
        case types.WEIGHT_SETTING_SAVED: {
            return {
                ...state,
                [action.compName + "SaveSuccess"]: true
            };
        }
        case types.WEIGHT_SETTING_SAVE_ERROR: {
            return {
                ...state,
                [action.compName + "SaveSuccess"]: false
            };
        }
        // PRICE MATRIX
        case types.INITIALIZE_STORE_PRICE_MATRIX: {
            const copyState = {
                ...state,
                [action.compName + "Id"]: "",
                [action.compName + "Name"]: "",
                [action.compName + "Status"]: true,
                [action.compName + "UnitOfMeasurement"]: null,
                [action.compName + "SaveSuccess"]: null,
                error: null
            };

            for (let name in copyState) {
                if (copyState.hasOwnProperty(name) && name.indexOf(action.compName + "Details") !== -1) {
                    if (name.indexOf(`${action.compName}DetailsPrice`) !== -1 || name.indexOf(`${action.compName}DetailsMemberPrice`) !== -1 || name.indexOf(`${action.compName}DetailsIsCampaign`) !== -1) {
                        delete copyState[name];
                    }
                }
            }

            return {
                ...copyState
            };
        }
        case types.PRICE_MATRIX_GOT: {
            let details = {};
            action.priceMatrix.priceMatrixDetails.map((item) => {
                details[`${action.compName}DetailsPrice${item.weightSettingId}`] = item.price.toFixed(2);
                details[`${action.compName}DetailsMemberPrice${item.weightSettingId}`] = item.memberPrice.toFixed(2);
                details[`${action.compName}DetailsIsCampaign_${item.weightSettingId}`] = item.isCampaign;
            });

            return {
                ...state,
                [action.compName + "Id"]: action.priceMatrix.id.toString(),
                [action.compName + "Name"]: action.priceMatrix.name,
                [action.compName + "Status"]: action.priceMatrix.status === "Active" ? true : false,
                [action.compName + "SaveSuccess"]: null,
                ...details
            };
        }
        case types.APPLY_MEMBER_DISCOUNT_PRICE_MATRIX: {
            let prices = {};

            let data = { ...state };

            // get data for details
            for (let name in data) {
                if (data.hasOwnProperty(name) && name.indexOf(action.compName) !== -1) {
                    if (name.indexOf(`${action.compName}Price`) !== -1) {
                        let weightId = name.split(`${action.compName}Price`)[1];
                        prices[`${action.compName}MemberPrice${weightId}`] =
                            data[`${action.compName}Price${weightId}`]
                                ? (parseFloat(data[`${action.compName}Price${weightId}`]) * (1 - action.discount)).toFixed(2)
                                : 0.00;
                    }
                }
            }
            return {
                ...state,
                ...prices
            };
        }
        case types.PRICE_MATRIX_SAVED: {
            return {
                ...state,
                [action.compName + "SaveSuccess"]: true
            };
        }
        case types.PRICE_MATRIX_SAVE_ERROR: {
            return {
                ...state,
                [action.compName + "SaveSuccess"]: false,
                [action.compName + "SaveError"]: action.error
            };
        }
        case types.PRICE_MATRIX_PRODUCTS_APPLIED: {
            return {
                ...state,
                ["applyPriceMatrixProductSaveSuccess"]: true
            };

        }
        case types.PRICE_MATRIX_PRODUCTS_APPLY_ERROR: {
            return {
                ...state,
                ["applyPriceMatrixProductSaveSuccess"]: false
            };
        }
        // POS
        case types.INITIALIZE_STORE_POS: {
            return {
                ...state,
                [action.compName + "Patient"]: null,
                [action.compName + "Quantity"]: 0,
                [action.compName + "PriceMatrixSelectedRows"]: null,
                ["posNewProductOrder"]: null,
                ["posNewComboProductOrder"]: null,
                ["posOrderCancelled"]: null
            };
        }
        case types.LINK_PATIENT_POS_ORDER: {
            return {
                ...state,
                [action.compName + "Patient"]: action.patient
            };
        }
        case types.INITIALIZE_POS_ADD_PRODUCT: {
            return {
                ...state,
                [action.compName + "PriceEstimation"]: '',
                [action.compName + "Quantity"]: 0,
                [action.compName + "PriceMatrixSelectedRows"]: null,
                [action.compName + "Amount"]: null
            };
        }
        case types.ADD_PRODUCT_TO_POS_ORDER: {
            return {
                ...state,
                ["posNewProductOrder"]: action.product
            };
        }
        case types.ADD_COMBO_PRODUCT_TO_POS_ORDER: {
            return {
                ...state,
                ["posNewComboProductOrder"]: action.comboProducts
            }
        }
        case types.POS_ORDER_SAVED: {
            return {
                ...state,
                ["posNewProductOrder"]: null,
                ["posNewComboProductOrder"]: null,
                posOrderSaveSuccess: new Date().toLocaleString(),
                ["PackageReference"]: null,
                ["PackageReferenceText"]: null
            };
        }
        case types.POS_ORDER_CANCELLED: {
            return {
                ...state,
                ["posOrderCancelled"]: true
            };
        }
        case types.POS_ORDER_CANCELLED_ALL: {
            return {
                ...state,
                ["posOrderCancelledAll"]: true
            };
        }
        case types.FINALIZE_POS_ORDER_ERROR:
        case types.SAVE_POS_ORDER_ERROR: {
            return {
                ...state,
                ["posOrderCancelled"]: null,
                ["posNewProductOrder"]: null,
                ["posNewComboProductOrder"]: null,
                ["POSPatientPatient"]: null
            };
        }
        case types.CLEAR_POS_CANCELLATION: {
            return {
                ...state,
                ["POSOrderCancellationUserName"]: null,
                ["POSOrderCancellationPassword"]: null
            };
        }

        case types.GOT_WEIGHT_POS: {
            return {
                ...state,
                [action.compName + "Amount"]: action.data.toString()
            };
        }

        case types.SET_ORDER_PRODUCT_DISCOUNT_SUCCESS:
        case types.SET_ORDER_DISCOUNT_SUCCESS: {
            return {
                ...state,
                [action.compName + "SaveSuccess"]: true,
                [action.compName + "SaveError"]: null
            };
        }

    case types.REMOVE_ORDER_PRODUCT_DISCOUNT_SUCCESS:
    case types.REMOVE_ORDER_DISCOUNT_SUCCESS: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
        [action.compName + 'SaveError']: new Date().toLocaleString(),
      };
    }

    case types.SET_ORDER_PRODUCT_DISCOUNT_ERROR:
    case types.SET_ORDER_DISCOUNT_ERROR:
    case types.REMOVE_ORDER_PRODUCT_DISCOUNT_ERROR:
    case types.REMOVE_ORDER_DISCOUNT_ERROR: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
        [action.compName + 'SaveError']:
          (action.error ? action.error.error.toString() : '0') +
          '-' +
          new Date().toLocaleString(),
      };
    }

    case types.SET_PATIENT_REWARD_ERROR: {
      return {
        ...state,
        ['RewardPointsError']: action.error,
      };
    }

    case types.INITIALIZE_STORE_POS_PATIENT: {
      return {
        ...state,
        [action.compName + 'FirstName']: null,
        [action.compName + 'LastName']: null,
        [action.compName + 'IsNotMember']: false,
        [action.compName + 'MemberNumber']: null,
        [action.compName + 'Phone']: null,
        [action.compName + 'Email']: null,
        [action.compName + 'CardNumber']: null,
      };
    }

    case types.INITIALIZE_STORE_POS_REMOVE_DISCOUNT: {
      let copyState = { ...state };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}RemoveDiscount-`) !== -1
        ) {
          delete copyState[name];
        }
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}RemoveProductDiscount-`) !== -1
        ) {
          delete copyState[name];
        }
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}RemovePriceByQuantityDiscount-`) !==
            -1
        ) {
          delete copyState[name];
        }
      }

      return {
        ...copyState,
      };
    }

    case types.INITIALIZE_STORE_POS_DISCOUNT: {
      let copyState = {
        ...state,
        [`${action.compName}Username`]: '',
        [`${action.compName}Password`]: '',
        [`${action.compName}PinCode`]: '',
        [`${action.compName}Notes`]: '',
        [`${action.compName}IsPercentage`]: false,
        [`${action.compName}Amount`]: '0',
        [`${action.compName}Percentage`]: '0',
        [`${action.compName}CustomizedDiscountSelection`]: null,
        [`${action.compName}SaveSuccess`]: null,
        [`${action.compName}SaveError`]: null,
        [`POSDiscountRewardAmount`]: '0',
        error: null,
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          (name.indexOf(`${action.productsCompName}Type-`) !== -1 ||
            name.indexOf(`${action.productsCompName}Amount-`) !== -1 ||
            name.indexOf(`${action.productsCompName}AlpineIQRewardPoints-`) !==
              -1 ||
            name.indexOf(`${action.productsCompName}AlpineIQRedeemURL-`) !==
              -1 ||
            name.indexOf(`${action.productsCompName}AlpineOptions-`) !== -1 ||
            name.indexOf(`${action.productsCompName}NewPrice-`) !== -1 ||
            name.indexOf(`${action.productsCompName}Percentage-`) !== -1)
        ) {
          delete copyState[name];
        }
      }

      return {
        ...copyState,
      };
    }

    case types.ORDER_EMAIL_RECEIPT_SENT: {
      return {
        ...state,
        ['posEmailReceiptSuccess']: new Date().toLocaleString(),
      };
    }

    case types.ORDER_SMS_RECEIPT_SENT: {
      return {
        ...state,
        ['posSMSReceiptSuccess']: true,
      };
    }

    // DECIVE
    case types.INITIALIZE_STORE_DEVICE: {
      return {
        ...state,
        [action.compName + 'Id']: '',
        [action.compName + 'Name']: '',
        [action.compName + 'IPAddress']: '',
        [action.compName + 'PINPadId']: '',
        [action.compName + 'DeviceType']: '',
        [action.compName + 'DeviceRole']: '',
        [action.compName + 'DeviceWorkStation']: '',
        [action.compName + 'Status']: true,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveError']: null,
        error: null,
      };
    }
    case types.DEVICE_GOT: {
      return {
        ...state,
        [action.compName + 'Id']: action.device.id.toString(),
        [action.compName + 'DeviceType']: action.device.deviceTypeId.toString(),
        [action.compName + 'DeviceRole']: action.device.deviceRoleId.toString(),
        [action.compName + 'DeviceWorkStation']:
          action.device.deviceWorkStationId.toString(),
        [action.compName + 'IPAddress']: action.device.ipAddress,
        [action.compName + 'PINPadId']: action.device.pinPadId,
        [action.compName + 'PINPadIntegrated']: action.device.pinPadIntegrated,
        [action.compName + 'Status']:
          action.device.status === 'Online' ? true : false,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveError']: null,
      };
    }
    case types.DEVICE_SAVED: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
      };
    }
    case types.DEVICE_SAVE_ERROR: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
      };
    }

    case types.GETIPADDRESS: {
      return {
        ...state,
        [action.compName + 'NewIPAddress']: action.ipaddress,
        [action.compName + 'IPAddress']: action.ipaddress,
      };
    }

    case types.UPDATEIPADDRESS: {
      return {
        ...state,
        [action.compName + 'IPAddress']: action.ipaddress,
      };
    }

    case types.UPDATE_DEVICE_IP_ERROR: {
      return {
        ...state,
        updateDeviceIpSaveError:
          action.error + ' - ' + new Date().toLocaleString(),
      };
    }
    // DECIVE ROLE
    case types.INITIALIZE_STORE_DEVICE_ROLE: {
      return {
        ...state,
        [action.compName + 'Name']: '',
        [action.compName + 'Description']: '',
        [action.compName + 'Status']: true,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveError']: null,
        error: null,
      };
    }

    case types.DEVICEROLE_SAVED: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
        [action.compName + 'SaveError']: null,
      };
    }

    case types.SAVE_DEVICEROLE_ERROR: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
        [action.compName + 'SaveError']:
          action.error + ' - ' + new Date().toLocaleString(),
      };
    }

    // DECIVE WORKSTATION
    case types.INITIALIZE_STORE_DEVICE_WORKSTATION: {
      return {
        ...state,
        [action.compName + 'Name']: '',
        [action.compName + 'Description']: '',
        [action.compName + 'Status']: true,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveError']: null,
        error: null,
      };
    }

    case types.DEVICEWORKSTATION_SAVED: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
        [action.compName + 'SaveError']: null,
      };
    }

    case types.DEVICEWORKSTATION_SAVE_ERROR: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
        [action.compName + 'SaveError']:
          action.error + ' - ' + new Date().toLocaleString(),
      };
    }

    // PAYMENT
    case types.INITIALIZE_STORE_PAYMENT: {
      return {
        ...state,
        [action.compName + 'Id']: '',
        [action.compName + 'Name']: '',
        [action.compName + 'Status']: true,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveError']: null,
        error: null,
      };
    }
    case types.PAYMENT_GOT: {
      return {
        ...state,
        [action.compName + 'Id']: action.payment.id.toString(),
        [action.compName + 'Name']: action.payment.name,
        [action.compName + 'Rate']: action.payment.rate,
        [action.compName + 'Status']:
          action.payment.status === 'Active' ? true : false,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveError']: null,
        error: null,
      };
    }
    case types.PAYMENT_SAVED: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
      };
    }
    case types.PAYMENT_SAVE_ERROR: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
      };
    }

    // TAXRATE
    case types.INITIALIZE_STORE_TAXRATE: {
      return {
        ...state,
        [action.compName + 'Id']: '',
        [action.compName + 'Name']: '',
        [action.compName + 'Rate']: '',
        [action.compName + 'Status']: true,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveError']: null,
        error: null,
      };
    }
    case types.TAXRATE_SAVED: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
      };
    }
    case types.TAXRATE_SAVE_ERROR: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
      };
    }

    case types.TAXRATE_GOT: {
      return {
        ...state,
        [action.compName + 'Id']: action.taxrate.id.toString(),
        [action.compName + 'Name']: action.taxrate.name,
        [action.compName + 'Rate']: action.taxrate.rate.toFixed(2).toString(),
        [action.compName + 'Status']:
          action.taxrate.status === 'Active' ? true : false,
        [action.compName + 'Value']: action.taxrate.value,
        [action.compName + 'ExcludeBranches']: !!action.taxrate.excludeBranches,
        [action.compName + 'BranchIdsToExclude']:
          action.taxrate.branchIdsToExclude
        ? action.taxrate.branchIdsToExclude
            .split(',')
            .map(x => parseInt(x.trim(), 10))
            .filter(x => !isNaN(x))
        : [],
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveError']: null,
        error: null,
      };
    }

    // CASH FLOW
    case types.CASHFLOW_CASHOUT_VERIFIED:
    case types.CASHFLOW_CASHOUT_NOT_VERIFIED: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
      };
    }
    case types.CASHFLOW_CASHOUT_ERROR: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
        [action.compName + 'SaveError']:
          action.error + ' - ' + new Date().toLocaleString(),
      };
    }

    case types.CASHFLOW_REGISTERS_CLOSED: {
      return {
        ...state,
        ['closeRegistersSaveSuccess']: true,
        ['closeRegistersSaveError']: null,
      };
    }

    case types.CASHFLOW_REGISTERS_CLOSED_FROM_CASHIN: {
      return {
        ...state,
        ['closeRegistersFromCashinSaveSuccess']: true,
        ['closeRegistersSaveError']: null,
      };
    }

    case types.CASHFLOW_CLOSE_REGISTERS_ERROR: {
      return {
        ...state,
        ['closeRegistersSaveSuccess']: false,
        ['closeRegistersSaveError']:
          action.error + ' - ' + new Date().toLocaleString(),
      };
    }

    case types.CASHFLOW_SAVED_CASHDROP: {
      return {
        ...state,
        ['cashDropSaveSuccess']: new Date().toLocaleString(),
        ['cashDropSaveError']: null,
      };
    }

    case types.CASHFLOW_SAVE_CASHDROP_ERROR: {
      return {
        ...state,
        ['cashDropSaveSuccess']: null,
        ['cashDropSaveError']:
          action.error + ' - ' + new Date().toLocaleString(),
      };
    }

    //ORDER
    case types.CLEAR_ADMIN_ORDER_CANCELLATION: {
      return {
        ...state,
        ['openOrderCancellationNotes']: null,
      };
    }
        
    // TRANSFER
    case types.CLEAR_WAREHOUSE_DATA: {
      let copyState = {
        ...state,
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(action.compName) !== -1 &&
          (name.indexOf('Amount') !== -1 ||
            name.indexOf('ToWarehouse') !== -1 ||
            name.indexOf('Checkbox') !== -1)
        ) {
          delete copyState[name];
        }
      }

      return {
        ...copyState,
        warehouseStockListTableSelectedRows: null,
      };
    }

    // CAMPAIGNS
    case types.CLEAR_CAMPAIGN_FORM: {
      let copyState = {
        ...state,
        [action.compName + 'Id']: null,
        [action.compName + 'Name']: null,
        [action.compName + 'Type']: null,
        [action.compName + 'StartDate']: null,
        [action.compName + 'EndDate']: null,
        [action.compName + 'DiscountType']: null,
        [action.compName + 'DiscountValue']: null,
        [action.compName + 'Description']: null,
        [action.compName + 'Status']: true,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveTimeStamp']: null,
        [action.compName + 'SaveError']: null,
        [action.compName + 'ApplyForMember']: false,
        [action.compName + 'ApplyForNonMember']: false,
        [action.compName + 'ApplyOnline']: false,
        [action.compName + 'ApplyInStore']: false,
        [action.compName + 'StartTime']: null,
        [action.compName + 'EndTime']: null,
        [action.compName + 'ApplyPriceByQuantity']: null,
        [action.compName + "AllowMixAndMatch"]: null,
        [action.compName + "IncrementalDiscount"]: null
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}WeekDay-`) !== -1
        ) {
          delete copyState[name];
        }
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}Product`) !== -1
        ) {
          delete copyState[name];
        }
      }

      return {
        ...copyState,
      };
    }

    case types.CAMPAIGN_GOT: {
      let daysOfWeek = {};
      action.data.daysOfWeekString.forEach((item) => {
        daysOfWeek[`${action.compName}WeekDay-${item}`] = true;
      });

      let productsPriceByQuantity = {};
      action.data.productsPriceByQuantity.forEach((item) => {
        let name = `${action.compName}Product${item.productId}-${item.id}`;
        productsPriceByQuantity[name + `RequiredQuantity`] =
          item.requiredQuantity;
        productsPriceByQuantity[name + `DiscountType`] = `${item.discountType}`;
        productsPriceByQuantity[name + `DiscountValue`] =
          item.discountType == 1
            ? item.discountValue.toFixed(0)
            : item.discountValue.toFixed(2);
      });

      return {
        ...state,
        [action.compName + 'Id']: action.data.id,
        [action.compName + 'Name']: action.data.name,
        [action.compName + 'Type']: action.data.type.toString(),
        [action.compName + 'StartDate']: action.data.dateFrom,
        [action.compName + 'ApplyForMember']: action.data.applyForMembersOnly,
        [action.compName + 'ApplyForNonMember']:
          action.data.applyForNonMembersOnly,
        [action.compName + 'ApplyOnline']: action.data.applyOnlineOnly,
        [action.compName + 'ApplyInStore']: action.data.applyInStoreOnly,
        [action.compName + 'EndDate']: action.data.dateTo,
        [action.compName + 'DiscountType']: action.data.discountType.toString(),
        [action.compName + 'DiscountValue']:
          action.data.discountTypeText === 'Percentage'
            ? action.data.discountValue.toFixed(0)
            : action.data.discountValue.toFixed(2),
        [action.compName + 'Description']: action.data.description,
        [action.compName + 'Status']: action.data.status === 1 ? true : false,
        [action.compName + 'StartTime']: action.data.startTime,
        [action.compName + 'EndTime']: action.data.endTime,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveTimeStamp']: null,
        [action.compName + 'SaveError']: null,
        [action.compName + 'ApplyPriceByQuantity']: action.data.applyPriceByQuantity,
        [action.compName + "AllowMixAndMatch"]: action.data.allowMixAndMatch,
        [action.compName + "IncrementalDiscount"]: action.data.incrementalDiscount,
        ...daysOfWeek,
        ...productsPriceByQuantity,
      };
    }

    case types.CAMPAIGN_GOT_ALL_ERROR: {
      return {
        ...state,
      };
    }

    case types.CAMPAIGN_SAVED: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
        [action.compName + 'SaveTimeStamp']: new Date().toString(),
        [action.compName + 'SaveError']: null,
      };
    }

    case types.CAMPAIGN_SAVED_ERROR: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
        [action.compName + 'SaveTimeStamp']: new Date().toString(),
        [action.compName + 'SaveError']: action.error,
      };
    }

    case types.CLEAR_CAMPAIGN_ITEMS_DIALOG: {
      let copyState = {
        ...state,
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}ProductCategory-`) !== -1
        ) {
          delete copyState[name];
        }
      }

      return {
        ...copyState,
        [`${action.compName}CampaignProductSearchText`]: null,
        [`${action.compName}CategorySearch`]: null,
        [`${action.compName}PriceMatrixSearch`]: null,
        [`${action.compName}DialogProductType`]: null,
        [`${action.compName}BrandSearchText`]: null,
        [`${action.compName}PoSearchText`]: null,
        [`${action.compName}WeightSearch`]: null,
      };
    }

    //COMBO
    case types.COMBO_GET_SUCCESS: {
      let comboProductList = {};
      action.data.products.map((item) => {
        comboProductList[`${action.compName}_${item.id}`] = item.quantity;
      });

      let daysOfWeek = {};
      action.data.daysOfWeekString.forEach((item) => {
        daysOfWeek[`${action.compName}WeekDay-${item}`] = true;
      });

      return {
        ...state,
        [action.compName + 'Id']: action.data.id,
        [action.compName + 'Name']: action.data.name,
        [action.compName + 'Price']: action.data.price
          ? action.data.price.toFixed(2)
          : 0,
        [action.compName + 'Status']: action.data.status === 1 ? true : false,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveTimeStamp']: null,
        [action.compName + 'SaveError']: null,
        [action.compName + 'StartDate']: action.data.dateFrom,
        [action.compName + 'EndDate']: action.data.dateTo,
        [action.compName + 'StartTime']: action.data.startTime,
        [action.compName + 'EndTime']: action.data.endTime,
        ...comboProductList,
        ...daysOfWeek,
      };
    }

    case types.CLEAR_COMBO_FORM: {
      let copyState = {
        ...state,
        [action.compName + 'Id']: null,
        [action.compName + 'Name']: null,
        [action.compName + 'Price']: null,
        [action.compName + 'Status']: true,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveTimeStamp']: null,
        [action.compName + 'SaveError']: null,
        [action.compName + 'StartDate']: null,
        [action.compName + 'EndDate']: null,
        [action.compName + 'StartTime']: null,
        [action.compName + 'EndTime']: null,
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}WeekDay-`) !== -1
        ) {
          delete copyState[name];
        }
      }
      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}`) !== -1
        ) {
          delete copyState[name];
        }
      }

      return {
        ...copyState,
      };
    }

    case types.CLEAR_COMBO_ITEMS_DIALOG: {
      let copyState = {
        ...state,
      };
      return {
        ...copyState,
        [`${action.compName}comboProductSearchText`]: null,
        [`${action.compName}comboProductSearchSKU`]: null,
      };
    }

    case types.COMBO_GET_ALL_FAIL: {
      return {
        ...state,
      };
    }

    case types.COMBO_SAVE_SUCCESS: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
        [action.compName + 'SaveTimeStamp']: new Date().toString(),
        [action.compName + 'SaveError']: null,
      };
    }

    case types.COMBO_SAVE_FAIL: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
        [action.compName + 'SaveTimeStamp']: new Date().toString(),
        [action.compName + 'SaveError']: action.error,
      };
    }

    case types.CHECK_COMBO_PRODUCT_QUANTITY_SUCCESS: {
      return {
        ...state,
        ['ComboCheckSuccess']: true,
        ['ComboCheckTimeStamp']: new Date().toString(),
        ['ComboCheckError']: null,
      };
    }

    case types.CHECK_COMBO_PRODUCT_QUANTITY_FAILURE: {
      return {
        ...state,
        ['ComboCheckSuccess']: false,
        ['ComboCheckTimeStamp']: new Date().toString(),
        ['ComboCheckError']: action.error,
      };
    }

    //AUDIT

    case types.AUDIT_SAVE_SUCCESS: {
      return {
        ...state,
        ['InventoryAuditSaveSuccess']: true,
        ['InventoryAuditSaveTimeStamp']: new Date().toString(),
        ['InventoryAuditCreatedId']: action.createdId,
        ['InventoryAuditSaveError']: null,
      };
    }

    case types.AUDIT_UPDATE_SUCCESS: {
      return {
        ...state,
        ['InventoryAuditUpdateTimeStamp']: new Date().toString(),
      };
    }

    case types.AUDIT_SAVE_FAIL: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
        [action.compName + 'SaveTimeStamp']: new Date().toString(),
        [action.compName + 'SaveError']: action.error,
      };
    }

    //CUSTOMIZED DISCOUNT

    case types.DISCOUNT_GET_SUCCESS: {
      return {
        ...state,
        [action.compName + 'Id']: action.data.id,
        [action.compName + 'Name']: action.data.name,
        [action.compName + 'Value']: action.data.value
          ? action.data.value.toFixed(2)
          : 0,
        [action.compName + 'Status']: action.data.status === 1 ? true : false,
        [action.compName + 'CustomizedDiscountType']:
          action.data.customizedDiscountType === 1 ? true : false,
        [action.compName + 'PromotionCode']: action.data.promotionCode,
        [action.compName + 'MinimumAmountToApplyPromotionCode']: action.data
          .minimumAmountToApplyPromotionCode
          ? action.data.minimumAmountToApplyPromotionCode.toFixed(2)
          : 0,
        [action.compName + 'StickyCardsDiscount']:
          action.data.stickyCardsDiscount,
        [action.compName + 'StickyCardPointsNeededToApply']: action.data
          .stickyCardPointsNeededToApply
          ? action.data.stickyCardPointsNeededToApply.toFixed(2)
          : 0,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveTimeStamp']: null,
        [action.compName + 'SaveError']: null,
      };
    }

    case types.CLEAR_DISCOUNT_FORM: {
      let copyState = {
        ...state,
        [action.compName + 'Id']: null,
        [action.compName + 'Name']: null,
        [action.compName + 'Value']: null,
        [action.compName + 'CustomizedDiscountType']: null,
        [action.compName + 'Status']: true,
        [action.compName + 'StickyCardsDiscount']: false,
        [action.compName + 'StickyCardPointsNeededToApply']: null,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveTimeStamp']: null,
        [action.compName + 'SaveError']: null,
      };

      return {
        ...copyState,
      };
    }

    case types.DISCOUNT_GET_ALL_FAIL: {
      return {
        ...state,
      };
    }

    case types.DISCOUNT_SAVE_SUCCESS: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
        [action.compName + 'SaveTimeStamp']: new Date().toString(),
        [action.compName + 'SaveError']: null,
      };
    }

    case types.DISCOUNT_SAVE_FAIL: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
        [action.compName + 'SaveTimeStamp']: new Date().toString(),
        [action.compName + 'SaveError']: action.error,
      };
    }

    //REFUND
    case types.CLEAN_REFUND_FORM: {
      const copyState = {
        ...state,
        [action.compName + 'Username']: '',
        [action.compName + 'Password']: '',
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveError']: null,
      };

      for (let name in copyState) {
        if (
          (copyState.hasOwnProperty(name) &&
            name.indexOf(action.compName + 'Quantity') !== -1) ||
          name.indexOf(action.compName + 'RefundReason') !== -1
        ) {
          delete copyState[name];
        }
      }

      return {
        ...copyState,
      };
    }

    case types.ADDED_REFUND_ORDER: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: true,
        [action.compName + 'SaveError']: null,
      };
    }

    case types.ADD_REFUND_ORDER_ERROR: {
      return {
        ...state,
        [action.compName + 'SaveSuccess']: false,
        [action.compName + 'SaveError']:
          (action.error ? action.error.error.toString() : '0') +
          '-' +
          new Date().toLocaleString(),
      };
    }

    case types.CLOCKIN_CLOCKOUT_SAVED: {
      return {
        ...state,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveSuccess`]: true,
        [`${action.compName}SaveSuccessMessage`]: action.data,
        [`${action.compName}SaveError`]: null,
      };
    }

    case types.SAVE_CLOCKIN_CLOCKOUT_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveSuccessMessage`]: null,
        [`${action.compName}SaveError`]: action.error,
        [`${action.compName}ErrorHasBranchInfo`]: action.branchInfo,
      };
    }

    // SHIFT
    case types.EMPLOYEE_SHIFT_GOT: {
      return {
        ...state,
        [`${action.compName}ID`]: action.data.employeeId.toString(),
        [`${action.compName}FirstName`]: action.data.employeeFirstName,
        [`${action.compName}LastName`]: action.data.employeeLastName,
        [`${action.compName}Date`]: new Date(
          action.data.punchInDate
        ).toLocaleString(),
        [`${action.compName}SaveSuccess`]: null,
        [`${action.compName}SaveTimestamp`]: null,
        [`${action.compName}SaveError`]: null,
      };
    }

    case types.CLEAN_EMPLOYEE_SHIFT_FORM: {
      let copyState = {
        ...state,
        [action.compName + 'ID']: null,
        [action.compName + 'FirstName']: null,
        [action.compName + 'LastName']: null,
        [action.compName + 'Date']: null,
        [action.compName + 'SaveSuccess']: null,
        [action.compName + 'SaveTimestamp']: null,
        [action.compName + 'SaveError']: null,
      };

      for (let name in copyState) {
        if (copyState.hasOwnProperty(name)) {
          if (name.indexOf(`${action.compName}-ClockIn-`) !== -1) {
            delete copyState[name];
          }
          if (name.indexOf(`${action.compName}-ClockOut-`) !== -1) {
            delete copyState[name];
          }
          if (name.indexOf(`${action.compName}-PaidBreak-`) !== -1) {
            delete copyState[name];
          }
          if (name.indexOf(`${action.compName}-Notes-`) !== -1) {
            delete copyState[name];
          }
          if (name.indexOf(`${action.compName}-Approve-`) !== -1) {
            delete copyState[name];
          }
        }
      }

      return {
        ...copyState,
      };
    }

    case types.EMPLOYEE_SHIFT_SAVED: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: true,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: null,
      };
    }

    case types.SAVE_EMPLOYEE_SHIFT_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: action.error,
      };
    }

    case types.SHIFT_SAVED: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: true,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: null,
      };
    }

    case types.SAVE_SHIFT_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: action.error,
      };
    }

    // APPLICATION SETTING
    case types.APPLICATION_SETTING_GOT: {
      return {
        ...state,
        [`${action.compName}Id`]: action.data.id.toString(),
        [`${action.compName}tokenName`]: action.data.tokenName,
        [`${action.compName}deviceKeyName`]: action.data.deviceKeyName,
        [`${action.compName}ageValidation`]:
          action.data.ageValidation.toString(),
        [`${action.compName}memberDiscountPercentage`]:
          action.data.memberDiscountPercentage.toFixed(2),
        [`${action.compName}salesPersonDiscountThreshold`]:
          action.data.salesPersonDiscountThreshold.toFixed(2),
        [`${action.compName}cashInAmountByDefault`]:
          action.data.cashInAmountByDefault.toFixed(2),
        [`${action.compName}cashDropAmount`]:
          action.data.cashDropAmount.toFixed(2),
        [`${action.compName}suggestedCashDropAmount`]:
          action.data.suggestedCashDropAmount.toFixed(2),
        [`${action.compName}cashDropAmountToKeep`]:
          action.data.cashDropAmountToKeep.toFixed(2),
        [`${action.compName}preRollCategoryId`]:
          action.data.preRollCategoryId.toString(),
        [`${action.compName}toleranceCashOutAmount`]:
          action.data.toleranceCashOutAmount.toFixed(2),
        [`${action.compName}doNotShowUnitProductQuantityOver`]:
          action.data.doNotShowUnitProductQuantityOver.toFixed(2),
        [`${action.compName}doNotShowWeightProductQuantityOver`]:
          action.data.doNotShowWeightProductQuantityOver.toFixed(2),
        [`${action.compName}name`]: action.data.name,
        [`${action.compName}phone`]: action.data.phone,
        [`${action.compName}site`]: action.data.webSite,
        [`${action.compName}street`]: action.data.address,
        [`${action.compName}city`]: action.data.city,
        [`${action.compName}provinceState`]: action.data.provinceState,
        [`${action.compName}country`]: action.data.country,
        [`${action.compName}postalCode`]: action.data.postalCode,
        [`${action.compName}EnablePinPassword`]: action.data.enablePinPassword,
        [`${action.compName}email`]: action.data.email,
        [`${action.compName}gstNumber`]: action.data.gstNumber,
        [`${action.compName}numberOfCopies`]: action.data.numberOfCopies,
        [`${action.compName}posReceiptBottomText`]:
          action.data.posReceiptBottomText,
        [`${action.compName}SaveSuccess`]: null,
        [`${action.compName}SaveError`]: null,
        [`${action.compName}showOpenOnlineOrders`]:
          action.data.showOpenOnlineOrders,
        [`${action.compName}showOpenOrders`]: action.data.showOpenOrders,
        [`${action.compName}crsaNumber`]: action.data.crsaNumber,
        [`${action.compName}primaryContactFullName`]:
          action.data.primaryContactFullName,
        [`${action.compName}primaryContactEmail`]:
          action.data.primaryContactEmail,
        [`${action.compName}secondaryContactFullName`]:
          action.data.secondaryContactFullName,
        [`${action.compName}secondaryContactEmail`]:
          action.data.secondaryContactEmail,
        [`${action.compName}managementEmployeeCount`]:
          action.data.managementEmployeeCount,
        [`${action.compName}administrativeEmployeeCount`]:
          action.data.administrativeEmployeeCount,
        [`${action.compName}salesEmployeeCount`]:
          action.data.salesEmployeeCount,
        [`${action.compName}productionEmployeeCount`]:
          action.data.productionEmployeeCount,
        [`${action.compName}otherEmployeeCount`]:
          action.data.otherEmployeeCount,
        [`${action.compName}RefundNeedManagerApproval`]:
          action.data.refundNeedManagerApproval,
        [`${action.compName}DiscountNeedManagerApproval`]:
          action.data.discountNeedManagerApproval,
        [`${action.compName}storeOpenHour`]: action.data.storeOpenHour,
        [`${action.compName}storeCloseHour`]: action.data.storeCloseHour,
        [`${action.compName}receiptShowEmployeeFirstName`]:
          action.data.receiptShowEmployeeFirstName,
        [`${action.compName}receiptShowEmployeeLastName`]:
          action.data.receiptShowEmployeeLastName,
        [`${action.compName}receiptShowGSTNumber`]:
          action.data.receiptShowGSTNumber,
        [`${action.compName}receiptShowMemberSavings`]:
          action.data.receiptShowMemberSavings,
        [`${action.compName}receiptShowOrderNumber`]:
          action.data.receiptShowOrderNumber,
        [`${action.compName}receiptShowProductCount`]:
          action.data.receiptShowProductCount,
        [`${action.compName}receiptShowTerminal`]:
          action.data.receiptShowTerminal,
        [`${action.compName}receiptShowMemberName`]:
          action.data.receiptShowMemberName,
        [`${action.compName}receiptShowVisitCount`]:
          action.data.receiptShowVisitCount,
        [`${action.compName}receiptShowMemberPoints`]:
          action.data.receiptShowMemberPoints,
        [`${action.compName}receiptShowCreatedDate`]:
          action.data.receiptShowCreatedDate,
        [`${action.compName}internalMessage`]: action.data.internalMessage,
        [`${action.compName}bannerImageURL`]: action.data.bannerImageURL,
        [`${action.compName}OCSHashKey`]: action.data.ocsHashKey,
        [`${action.compName}StackDiscountEnable`]:
          action.data.stackDiscountsEnabled,
        [`${action.compName}GenericGiftCardEnabled`]:
          action.data.genericGiftCardEnabled,
        [`${action.compName}HideSearchBar`]: action.data.hideSearchBar,
        [`${action.compName}ReceivePurchaseOrderWhenCreate`]:
          action.data.receivePurchaseOrderWhenCreate,
        [`${action.compName}TaxExemptAllEnabled`]:
          action.data.taxExemptAllEnabled,
        [`${action.compName}StoreCreditExpirationDays`]:
          action.data.storeCreditExpirationDays,
        [`${action.compName}showPOSBulkImport`]: action.data.showPOSBulkImport,
        [`${action.compName}ShowAddMemberAfterSale`]:
          action.data.showAddMemberAfterSale,
        [`${action.compName}IsAutoLogoutPinEnabled`]: action.data
          .logoutPinAfterSeconds
          ? true
          : false,
        [`${action.compName}LogoutPinAfterSeconds`]:
          action.data.logoutPinAfterSeconds,
        [`${action.compName}OfflineProductScan`]:
          action.data.offlineProductScan,
        [`${action.compName}CachingProducts`]: action.data.cachingProducts,
      };
    }

    // APPLICATION SETTING
    case types.APPLICATION_SETTING_SAVED: {
      return {
        ...state,
        [`${action.compName}Id`]: action.data.id.toString(),
        [`${action.compName}tokenName`]: action.data.tokenName,
        [`${action.compName}deviceKeyName`]: action.data.deviceKeyName,
        [`${action.compName}ageValidation`]:
          action.data.ageValidation.toString(),
        [`${action.compName}memberDiscountPercentage`]:
          action.data.memberDiscountPercentage.toFixed(2),
        [`${action.compName}salesPersonDiscountThreshold`]:
          action.data.salesPersonDiscountThreshold.toFixed(2),
        [`${action.compName}cashInAmountByDefault`]:
          action.data.cashInAmountByDefault.toFixed(2),
        [`${action.compName}cashDropAmount`]:
          action.data.cashDropAmount.toFixed(2),
        [`${action.compName}suggestedCashDropAmount`]:
          action.data.suggestedCashDropAmount.toFixed(2),
        [`${action.compName}cashDropAmountToKeep`]:
          action.data.cashDropAmountToKeep.toFixed(2),
        [`${action.compName}preRollCategoryId`]:
          action.data.preRollCategoryId.toString(),
        [`${action.compName}toleranceCashOutAmount`]:
          action.data.toleranceCashOutAmount.toFixed(2),
        [`${action.compName}doNotShowUnitProductQuantityOver`]:
          action.data.doNotShowUnitProductQuantityOver.toFixed(2),
        [`${action.compName}doNotShowWeightProductQuantityOver`]:
          action.data.doNotShowWeightProductQuantityOver.toFixed(2),
        [`${action.compName}name`]: action.data.name,
        [`${action.compName}phone`]: action.data.phone,
        [`${action.compName}site`]: action.data.webSite,
        [`${action.compName}street`]: action.data.address,
        [`${action.compName}city`]: action.data.city,
        [`${action.compName}provinceState`]: action.data.provinceState,
        [`${action.compName}country`]: action.data.country,
        [`${action.compName}postalCode`]: action.data.postalCode,
        [`${action.compName}gstNumber`]: action.data.gstNumber,
        [`${action.compName}posReceiptBottomText`]:
          action.data.posReceiptBottomText,
        [`${action.compName}SaveSuccess`]: true,
        [`${action.compName}SaveError`]: null,
        [`${action.compName}showOpenOnlineOrders`]:
          action.data.showOpenOnlineOrders,
        [`${action.compName}showOpenOrders`]: action.data.showOpenOrders,
        [`${action.compName}crsaNumber`]: action.data.crsaNumber,
        [`${action.compName}primaryContactFullName`]:
          action.data.primaryContactFullName,
        [`${action.compName}primaryContactEmail`]:
          action.data.primaryContactEmail,
        [`${action.compName}secondaryContactFullName`]:
          action.data.secondaryContactFullName,
        [`${action.compName}secondaryContactEmail`]:
          action.data.secondaryContactEmail,
        [`${action.compName}managementEmployeeCount`]:
          action.data.managementEmployeeCount,
        [`${action.compName}administrativeEmployeeCount`]:
          action.data.administrativeEmployeeCount,
        [`${action.compName}salesEmployeeCount`]:
          action.data.salesEmployeeCount,
        [`${action.compName}productionEmployeeCount`]:
          action.data.productionEmployeeCount,
        [`${action.compName}otherEmployeeCount`]:
          action.data.otherEmployeeCount,
        [`${action.compName}refundNeedManagerApproval`]:
          action.data.refundNeedManagerApproval,
        [`${action.compName}DiscountNeedManagerApproval`]:
          action.data.discountNeedManagerApproval,
        [`${action.compName}storeOpenHour`]: action.data.storeOpenHour,
        [`${action.compName}storeCloseHour`]: action.data.storeCloseHour,
        [`${action.compName}NoSalesAllowedAfterStoreHours`]:
          action.data.noSalesAllowedAfterStoreHours,
        [`${action.compName}StackDiscountEnable`]:
          action.data.stackDiscountsEnabled,
        [`${action.compName}GenericGiftCardEnabled`]:
          action.data.genericGiftCardEnabled,
        [`${action.compName}ReceivePurchaseOrderWhenCreate`]:
          action.data.receivePurchaseOrderWhenCreate,
        [`${action.compName}TaxExemptAllEnabled`]:
          action.data.taxExemptAllEnabled,
        [`${action.compName}showPOSBulkImport`]: action.data.showPOSBulkImport,
        [`${action.compName}ShowAddMemberAfterSale`]:
          action.data.showAddMemberAfterSale,
        [`${action.compName}IsAutoLogoutPinEnabled`]: action.data
          .logoutPinAfterSeconds
          ? true
          : false,
        [`${action.compName}LogoutPinAfterSeconds`]:
          action.data.logoutPinAfterSeconds,
        [`${action.compName}OfflineProductScan`]:
          action.data.offlineProductScan,
        [`${action.compName}CachingProducts`]: action.data.cachingProducts,
      };
    }

    case types.GET_APPLICATION_SETTING_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: action.error,
      };
    }

    case types.SAVE_APPLICATION_SETTING_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: action.error,
      };
    }

    // MIX AND MATCH
    case types.CLEAN_MIX_AND_MATCH_FORM: {
      let copyState = {
        ...state,
        [`${action.compName}Id`]: null,
        [`${action.compName}Name`]: null,
        [`${action.compName}Description`]: null,
        [`${action.compName}Status`]: true,
        [`${action.compName}StartDate`]: null,
        [`${action.compName}EndDate`]: null,
        [`${action.compName}SaveSuccess`]: null,
        [`${action.compName}SaveTimestamp`]: null,
        [`${action.compName}SaveError`]: null,
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}PriceMatrix-`) !== -1
        ) {
          delete copyState[name];
        }
      }

      return { ...copyState };
    }

    case types.MIX_AND_MATCH_BY_ID_GOT: {
      const data = { ...action.data };
      return {
        ...state,
        [`${action.compName}Id`]: data.id.toString(),
        [`${action.compName}Name`]: data.name,
        [`${action.compName}Description`]: data.description,
        [`${action.compName}Status`]:
          data.status == 'Active' || data.status == 1 ? true : false,
        [`${action.compName}StartDate`]: data.dateFrom,
        [`${action.compName}EndDate`]: data.dateTo,
        [`${action.compName}SaveSuccess`]: null,
        [`${action.compName}SaveTimestamp`]: null,
        [`${action.compName}SaveError`]: null,
      };
    }

    case types.MIX_AND_MATCH_BY_ID_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: action.error,
      };
    }

    case types.SAVE_MIX_AND_MATCH_SUCCESS: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: true,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: null,
      };
    }

    case types.SAVE_MIX_AND_MATCH_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: action.error,
      };
    }

    case types.CLEAR_PRODUCT_GROUP_ITEMS_DIALOG: {
      let copyState = {
        ...state,
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}ProductCategory-`) !== -1
        ) {
          delete copyState[name];
        }
      }

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}ProductCampaign-`) !== -1
        ) {
          delete copyState[name];
        }
      }

      let campaigns = {};
      copyState.carouselSaveProductCampaigns.forEach(
        (campaign) =>
          (campaigns[`${action.compName}ProductCampaign-${campaign.id}`] = true)
      );

      return {
        ...copyState,
        ...campaigns,
        [`${action.compName}ProductSearchText`]: null,
        [`${action.compName}CategoryIdSearch`]: null,
        [`${action.compName}CategoryIdSearchText`]: null,
        [`${action.compName}PriceMatrixSearchText`]: null,
        [`${action.compName}DialogSearchProductType`]: null,
        [`${action.compName}PoSearchText`]: null,
        [`${action.compName}BrandSearchText`]: null,
        [`${action.compName}WeightSearch`]: null,
        [`${action.compName}SkuSearchText`]: null,
        [`${action.compName}PriceMatrixSearch`]: null,
      };
    }

    case types.PRODUCT_GROUP_LOAD_FORM: {
      const prodGroupFields = {
        [action.compName + 'Categories']: action.data.categories,
        [action.compName + 'Description']: action.data.description,
        [action.compName + 'Id']: action.data.id,
        [action.compName + 'IsMenu']: action.data.isMenu,
        [action.compName + 'Name']: action.data.name,
        [action.compName + 'ProductCategoryIds']:
          action.data.productCategoryIds,
        [action.compName + 'ProductIds']: action.data.productIds,
        [action.compName + 'Products']: action.data.products,
        [action.compName + 'Status']: action.data.status == 1 ? true : false,
      };

      return {
        ...state,
        ...prodGroupFields,
      };
    }
    case types.UPDATE_PRODUCT_GROUP_SAVED:
    case types.PRODUCT_GROUP_SAVED: {
      return {
        ...state,
        [`${action.compName}ProductGroup`]: action.data,
        [`${action.compName}SaveSuccess`]: true,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: null,
      };
    }
    case types.GET_STORE_RULE_BY_ID_SUCCESS: {
      let storeRuleContent = {};
      let copyState = {
        ...state,
        [`${action.compName}Name`]: action.data.name,
        [`${action.compName}Status`]: action.data.status == 2 ? false : true,
      };

      action.data.webStoreRulesContent.map((item) => {
        storeRuleContent[`${action.compName}Content_${item.id}`] = item.content;
      });

      return {
        ...copyState,
        ...storeRuleContent,
      };
    }

    case types.SAVE_STORE_RULES_SUCCESS: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: new Date().toLocaleString(),
      };
    }

    case types.SAVE_STORE_RULES_CONTENT_SUCCESS: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: new Date().toLocaleString(),
      };
    }
    case types.UPDATE_PRODUCT_GROUP_ERROR:
    case types.PRODUCT_GROUP_SAVE_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: action.errors.join('<br/>'),
      };
    }
    case types.INIT_PRODUCT_GROUP_FORM: {
      let copyState = {
        ...state,
        [`${action.compName}SaveSuccess`]: null,
        [`${action.compName}SaveTimestamp`]: null,
        [`${action.compName}SaveError`]: null,
        [`${action.compName}Status`]: true,
        [`${action.compName}Name`]: null,
        [`${action.compName}Description`]: null,
        [`${action.compName}IsMenu`]: true,
        [`${action.compName}DialogSearchProductType`]: '1',
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(
            `${action.compName}DialogProductCategorySearchProductCategory-`
          ) !== -1
        ) {
          delete copyState[name];
        }
      }

      return { ...copyState };
    }

    case types.INIT_CAROUSEL_PRODUCT_GROUP_FORM: {
      let copyState = {
        ...state,
        [`${action.compName}SaveSuccess`]: null,
        [`${action.compName}SaveTimestamp`]: null,
        [`${action.compName}SaveError`]: null,
        [`${action.compName}Status`]: true,
        [`${action.compName}Name`]: null,
        [`${action.compName}Description`]: null,
        [`${action.compName}IsMenu`]: false,
        [`${action.compName}DialogSearchProductType`]: '1',
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(
            `${action.compName}DialogProductCategorySearchProductCategory-`
          ) !== -1
        ) {
          delete copyState[name];
        }
      }

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}ProductCampaign-`) !== -1
        ) {
          delete copyState[name];
        }
      }

      return { ...copyState };
    }

    case types.INITIALIZE_BANNER_FORM: {
      const defaultValues = {
        [`${action.compName}BannerName`]: '',
        [`${action.compName}TargetUrl`]: '',
        [`${action.compName}BannerAlt`]: '',
        [`${action.compName}BannerType`]: 1,
        [`${action.compName}BannerDescription`]: '',
        [`${action.compName}IsGlobal`]: false,
        [`${action.compName}IsActive`]: true,
        [`${action.compName}DisplayOrder`]: 0,
        [`${action.compName}BranchId`]: 0,
    };

      const payloadValues = action.payload || {};

      return {
        ...state,
        ...defaultValues,
        ...payloadValues,
      };
    }
    case types.GET_PRODUCT_GROUP_BY_ID_GOT: {
      const data = { ...action.data };
      let categories = {};
      let campaigns = {};
      data.categories.forEach(
        (c) =>
          (categories[
            `${action.compName}DialogProductCategorySearchProductCategory-${c.id}`
          ] = true)
      );
      data.campaigns.forEach(
        (campaign) =>
          (campaigns[`${action.compName}ProductCampaign-${campaign.id}`] = true)
      );

      return {
        ...state,
        ...Object.keys(state)
          .filter((key) => key.startsWith(`${action.compName}ProductCampaign-`))
          .reduce((acc, key) => {
            acc[key] = false;
            return acc;
          }, {}),
        [`${action.compName}Name`]: data.name,
        [`${action.compName}Description`]: data.description,
        [`${action.compName}CarouselStartDate`]: data.startDate,
        [`${action.compName}CarouselEndDate`]: data.endDate,
        [`${action.compName}IsMenu`]: data.isMenu || false,
        [`${action.compName}Status`]: data.status == 2 ? false : true,
        [`${action.compName}Products`]: data.products,
        [`${action.compName}ProductCategories`]: data.categories,
        [`${action.compName}ProductCampaigns`]: data.campaigns,
        ...categories,
        ...campaigns,
      };
    }

    case types.UPDATE_PRODUCT_CAMPAIGNS: {
      let copyState = { ...state };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`${action.compName}ProductCampaign-`) !== -1
        ) {
          delete copyState[name];
        }
      }

      let campaigns = {};
      action.campaigns.forEach(
        (campaign) =>
          (campaigns[`${action.compName}ProductCampaign-${campaign.id}`] = true)
      );

      return {
        ...copyState,
        ...campaigns,
        [`${action.compName}ProductCampaigns`]: action.campaigns,
      };
    }

    case types.GET_PRODUCT_GROUP_BY_ID_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: action.errors.join('<br/>'),
      };
    }

    case types.GET_HOME_SETTINGS_SUCCESS: {
      return {
        ...state,
        homeSettingId: action.data.id,
        homeSettingCarousel: action.data.carouselProductGroupId,
        homeSettingList: action.data.webHomeListItems,
        homeSettingSaveSuccess: null,
        homeSettingSaveTimestamp: new Date().toLocaleString(),
        homeSettingSaveError: null,
      };
    }

    //HOME SETTINGS
    case types.HOME_SETTINGS_UPDATE_SUCCESS:
      return { ...state, homeSettingsUpdated: true };
    case types.SAVE_HOME_SETTINGS_SUCCESS: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: true,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: null,
      };
    }

    case types.HOME_SETTINGS_UPDATE_FAIL:
    case types.SAVE_HOME_SETTINGS_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveTimestamp`]: new Date().toLocaleString(),
        [`${action.compName}SaveError`]: action.errors.join('<br/>'),
      };
    }

    //PIN
    case types.NEW_PIN_SUCCESS: {
      return {
        ...state,
        [action.compName + 'Pin']: action.pin.newPinPassword,
      };
    }

    case types.VALIDATE_PIN_PASSWORD_SUCCESS: {
      return {
        ...state,
        error: {
          ...state.error,
          openDrawerPinCode: '',
        },
      };
    }

    case types.VALIDATE_PIN_PASSWORD_FAIL: {
      return {
        ...state,
        error: {
          ...state.error,
          openDrawerPinCode: action.message,
        },
      };
    }

    case 'SAVE_TO_SCHEDULE_FORM': {
      return {
        ...state,
        [action.model.compName + 'Date']: action.model.date
          ? action.model.date
          : moment.utc(action.model.start).startOf('day').format('LL'),
        [action.model.compName + 'DateStart']: action.model.date
          ? action.model.date
          : moment.utc(action.model.start).startOf('day').format('LL'),
        [action.model.compName + 'DateEnd']: action.model.date
          ? action.model.date
          : moment.utc(action.model.start).startOf('day').format('LL'),
        [action.model.compName + 'Start']: action.model.start,
        [action.model.compName + 'End']: action.model.end,
        [action.model.compName + 'Employee']: action.model.employee,
        [action.model.compName + 'Id']:
          action.model.id == null ? null : parseInt(action.model.id, 10),
        [action.model.compName + 'Status']: action.model.status,
        [action.model.compName + 'WeekDay-Monday']: action.model.monday,
        [action.model.compName + 'WeekDay-Tuesday']: action.model.tuesday,
        [action.model.compName + 'WeekDay-Wednesday']: action.model.wednesday,
        [action.model.compName + 'WeekDay-Thursday']: action.model.thursday,
        [action.model.compName + 'WeekDay-Friday']: action.model.friday,
        [action.model.compName + 'WeekDay-Saturday']: action.model.saturday,
        [action.model.compName + 'WeekDay-Sunday']: action.model.sunday,
        [action.model.compName + 'MondayStart']: action.model.MondayStart,
        [action.model.compName + 'MondayEnd']: action.model.MondayEnd,
        [action.model.compName + 'TuesdayStart']: action.model.TuesdayStart,
        [action.model.compName + 'TuesdayEnd']: action.model.TuesdayEnd,
        [action.model.compName + 'WednesdayStart']: action.model.WednesdayStart,
        [action.model.compName + 'WednesdayEnd']: action.model.WednesdayEnd,
        [action.model.compName + 'ThursdayStart']: action.model.ThursdayStart,
        [action.model.compName + 'ThursdayEnd']: action.model.ThursdayEnd,
        [action.model.compName + 'FridayStart']: action.model.FridayStart,
        [action.model.compName + 'FridayEnd']: action.model.FridayEnd,
        [action.model.compName + 'SaturdayStart']: action.model.SaturdayStart,
        [action.model.compName + 'SaturdayEnd']: action.model.SaturdayEnd,
        [action.model.compName + 'SundayStart']: action.model.SundayStart,
        [action.model.compName + 'SundayEnd']: action.model.SundayEnd,
        [action.model.compName + 'Color']: action.model.color,
        [action.model.compName + 'Recursive']: action.model.recursiveId,
        [action.model.compName + 'SelectedCustomTimeSlot']:
          action.model.SelectedCustomTimeSlot,
        [action.model.compName + 'SelectedCustomTimeSlotMonday']:
          action.model.SelectedCustomTimeSlotMonday,
        [action.model.compName + 'SelectedCustomTimeSlotTuesday']:
          action.model.SelectedCustomTimeSlotTuesday,
        [action.model.compName + 'SelectedCustomTimeSlotWednesday']:
          action.model.SelectedCustomTimeSlotWednesday,
        [action.model.compName + 'SelectedCustomTimeSlotThursday']:
          action.model.SelectedCustomTimeSlotThursday,
        [action.model.compName + 'SelectedCustomTimeSlotFriday']:
          action.model.SelectedCustomTimeSlotFriday,
        [action.model.compName + 'SelectedCustomTimeSlotSaturday']:
          action.model.SelectedCustomTimeSlotSaturday,
        [action.model.compName + 'SelectedCustomTimeSlotSunday']:
          action.model.SelectedCustomTimeSlotSunday,
      };
    }

    case types.GET_INVENTORY_ADJUST_SUCCESS: {
      let inventoryAdjust = {};
      let copyState = {
        ...state,
      };

      action.data.list.map((item) => {
        inventoryAdjust[`inventoryAdjust_actualQuantity_${item.productId}`] = (
          item.actualQty || 0
        ).toString();
        inventoryAdjust[`inventoryAdjust_displayName_${item.productId}`] =
          item.displayName;
        inventoryAdjust[`inventoryAdjust_showDS_${item.productId}`] =
          item.digitalSignageDisplayed;
        inventoryAdjust[`inventoryAdjust_webMenuDisplayed_${item.productId}`] =
          item.webMenuDisplayed;
        inventoryAdjust[`inventoryAdjust_isDailySpecial_${item.productId}`] =
          item.isDailySpecial;
        inventoryAdjust[`inventoryAdjust_salePrice_${item.productId}`] = (
          item.salePrice || 0
        ).toFixed(2);
        inventoryAdjust[`inventoryAdjust_memberPrice_${item.productId}`] = (
          item.memberPrice || 0
        ).toFixed(2);
        inventoryAdjust[`inventoryAdjust_priceMatrixId_${item.productId}`] =
          item.priceMatrixId;
        inventoryAdjust[`inventoryAdjust_margin_${item.productId}`] =
          item.salePrice > 0 && item.salePrice >= item.avgPurchasePrice
            ? (
                ((item.salePrice - item.avgPurchasePrice) / item.salePrice) *
                100
              ).toFixed(2)
            : 0;
        inventoryAdjust[`inventoryAdjust_markup_${item.productId}`] =
          item.salePrice > 0 && item.salePrice >= item.avgPurchasePrice
            ? (
                ((item.salePrice - item.avgPurchasePrice) /
                  item.avgPurchasePrice) *
                100
              ).toFixed(2)
            : 0;
        inventoryAdjust[`inventoryAdjust_latestMargin_${item.productId}`] =
          item.salePrice > 0 && item.salePrice >= item.latestPurchasePrice
            ? (
                ((item.salePrice - item.latestPurchasePrice) / item.salePrice) *
                100
              ).toFixed(2)
            : 0;
        inventoryAdjust[`inventoryAdjust_latestMarkup_${item.productId}`] =
          item.salePrice > 0 && item.salePrice >= item.latestPurchasePrice
            ? (
                ((item.salePrice - item.latestPurchasePrice) /
                  item.latestPurchasePrice) *
                100
              ).toFixed(2)
            : 0;
        inventoryAdjust[`inventoryAdjust_THCLevel_${item.productId}`] = (
          item.thcLevel || 0
        ).toFixed(2);
        inventoryAdjust[`inventoryAdjust_CBDLevel_${item.productId}`] = (
          item.cbdLevel || 0
        ).toFixed(2);
        inventoryAdjust[`inventoryAdjust_location_${item.productId}`] =
          item.location;
        inventoryAdjust[`inventoryAdjust_restockCap_${item.productId}`] =
          item.restockCap;
        inventoryAdjust[`inventoryAdjust_showSoldOut_${item.productId}`] =
          item.showSoldOut;
        inventoryAdjust[`inventoryAdjust_weightPerUnit_${item.productId}`] = (
          item.weightPerUnit || 0
        ).toFixed(2);
        inventoryAdjust[`inventoryAdjust_unitOfMeasurement_${item.productId}`] =
          (item.unitOfMeasurement || 0).toFixed(2);
        inventoryAdjust[`inventoryAdjust_estimatedQty_${item.productId}`] =
          item.estimatedQty || 0;
        inventoryAdjust[`inventoryAdjust_avgPOPrice_${item.productId}`] = (
          item.avgPurchasePrice || 0
        ).toFixed(2);
        inventoryAdjust[`inventoryAdjust_latestPOPrice_${item.productId}`] = (
          item.latestPurchasePrice || 0
        ).toFixed(2);
        inventoryAdjust[
          `inventoryAdjust_profitCalculatedFromLatestPO_${item.productId}`
        ] = true;
        inventoryAdjust[`inventoryAdjust_cbD_MAX_${item.productId}`] = (
          item.cbD_MAX || 0
        ).toFixed(2);
        inventoryAdjust[`inventoryAdjust_cbD_MIN_${item.productId}`] = (
          item.cbD_MIN || 0
        ).toFixed(2);
        inventoryAdjust[`inventoryAdjust_thC_MAX_${item.productId}`] = (
          item.thC_MAX || 0
        ).toFixed(2);
        inventoryAdjust[`inventoryAdjust_thC_MIN_${item.productId}`] = (
          item.thC_MIN || 0
        ).toFixed(2);
        inventoryAdjust[`inventoryAdjust_LotNumber_${item.productId}`] = '0';
      });
      return {
        ...copyState,
        ...inventoryAdjust,
      };
    }

    case types.PO_RECEIVE_BARCODE_EXIST: {
      let msg = action.message;
      let productName = msg.split('The Product Name is')[1];
      return {
        ...state,
        receivePOUPCExistProductName: productName,
        receivePOBarcodeExist: true,
      };
    }

    case types.UPC_EDIT_BARCODE_EXIST: {
      let msg = action.message;
      let productName = msg.split('The Product Name is')[1];
      return {
        ...state,
        editExistUPCProductName: productName,
        editupcBarcodeExist: true,
      };
    }

    case types.GET_WEB_UI_SETTINGS_SUCCESS: {
      return {
        ...state,
        [`${action.compName}headerBackgroundColor`]:
          action.data.headerBackgroundColor,
        [`${action.compName}headerBackgroundImageUrl`]:
          action.data.headerBackgroundImageUrl,
        [`${action.compName}headerForegroundColor`]:
          action.data.headerForegroundColor,
        [`${action.compName}headerLogoUrl`]: action.data.headerLogoUrl,
        [`${action.compName}headerBusinessName`]:
          action.data.headerBusinessName,
        [`${action.compName}bodyBackgroundColor`]:
          action.data.bodyBackgroundColor,
        [`${action.compName}bodyBackgroundImageUrl`]:
          action.data.bodyBackgroundImageUrl,
        [`${action.compName}bodyButtonBackgroudColor`]:
          action.data.bodyButtonBackgroudColor,
        [`${action.compName}bodyButtonForegroundColor`]:
          action.data.bodyButtonForegroundColor,
        [`${action.compName}footerBackgroundColor`]:
          action.data.footerBackgroundColor,
        [`${action.compName}footerBackgroundImageUrl`]:
          action.data.footerBackgroundImageUrl,
        [`${action.compName}footerForegroundColor`]:
          action.data.footerForegroundColor,
        [`${action.compName}footerLogoUrl`]: action.data.footerLogoUrl,
        [`${action.compName}footerBusinessName`]:
          action.data.footerBusinessName,
        [`${action.compName}footerAddress`]: action.data.footerAddress,
        [`${action.compName}footerPhone`]: action.data.footerPhone,
        [`${action.compName}footerVistTimeOne`]: action.data.footerVistTimeOne,
        [`${action.compName}footerVistTimeTwo`]: action.data.footerVistTimeTwo,
        [`${action.compName}footerVistTimeThree`]:
          action.data.footerVistTimeThree,
        [`${action.compName}footerTwoBackgroundColor`]:
          action.data.footerTwoBackgroundColor,
        [`${action.compName}footerTwoBackgroudImageUrl`]:
          action.data.footerTwoBackgroudImageUrl,
        [`${action.compName}footerTwoForegroundColor`]:
          action.data.footerTwoForegroundColor,
        [`${action.compName}colorStoreRulesText`]:
          action.data.colorStoreRulesText === null
            ? '#333333'
            : action.data.colorStoreRulesText,
        [`${action.compName}fontSizeStoreRulesContent`]:
          action.data.fontSizeStoreRulesContent,
        [`${action.compName}fontSizeStoreRulesHeader`]:
          action.data.fontSizeStoreRulesHeader,
        [`${action.compName}deliveryRadius`]: action.data.deliveryRadius,
        [`${action.compName}deliverToHomeEnabled`]:
          action.data.deliverToHomeEnabled,
        [`${action.compName}shippingCost`]: action.data.shippingCost,
        [`${action.compName}deliveryMininumAmountThreshold`]:
          action.data.deliveryMininumAmountThreshold,
        [`${action.compName}freeDeliveryThreshold`]:
          action.data.freeDeliveryThreshold,
        [`${action.compName}deliverySupplementaryText`]:
          action.data.deliverySupplementaryText,
        [`${action.compName}deliveryOrderEmailText`]:
          action.data.deliveryOrderEmailText,
        [`${action.compName}deliveryCostStep`]: action.data.deliveryCostStep,
        [`${action.compName}deliveryDistanceStep`]:
          action.data.deliveryDistanceStep,
        [`${action.compName}freeDeliveryDistanceCutoff`]:
          action.data.freeDeliveryDistanceCutoff,
        [`${action.compName}deliveryStartHour`]: action.data.deliveryStartTime,
        [`${action.compName}deliveryEndHour`]: action.data.deliveryEndTime,
        [`${action.compName}onlinePaymentEnabled`]:
          action.data.onlinePaymentEnabled,
        [`${action.compName}storePaymentEnabled`]:
          action.data.storePaymentEnabled,
        [`${action.compName}ageCheckerEnabled`]: action.data.ageCheckerEnabled,
        [`${action.compName}pickUpOrderReadyEmailText`]:
          action.data.pickUpOrderReadyEmailText,
        [`${action.compName}curbSidePickUpEnabled`]:
          action.data.curbSidePickUpEnabled,
        [`${action.compName}driveThroughPickUpEnabled`]:
          action.data.curbSidePickUpEnabled,
        [`${action.compName}shipToHomeCost`]: action.data.shipToHomeCost,
        [`${action.compName}shipToHomeEnabled`]: action.data.shipToHomeEnabled,
        [`${action.compName}id`]: action.data.id,
        [`${action.compName}endlessScroll`]: action.data.endlessScroll,
        [`${action.compName}snackbarBackgroundColor`]:
          action.data.snackbarBackgroundColor,
        [`${action.compName}enableStoreToDoor`]: action.data.enableStoreToDoor,
        [`${action.compName}storeToDoorCompanyId`]:
          action.data.storeToDoorCompanyId,
        [`${action.compName}storeToDoorLocationId`]:
          action.data.storeToDoorLocationId,
        [`${action.compName}DeliveryZone`]: action.data.deliveryZone,
        [`${action.compName}StoreLockDateAndTimeEnabled`]:
          action.data.storeLockDateAndTimeEnabled,
        [`${action.compName}sideCartModeEnabled`]:
          action.data.sideCartModeEnabled,
        [`${action.compName}enableStoreToDoorLockDateAndTime`]:
          action.data.enableStoreToDoorLockDateAndTime,
        [`${action.compName}bannerDisplayMode`]:
          action.data.bannerDisplayMode,
        [`${action.compName}showMemberPriceBeforeLogin`]:
          action.data.showMemberPriceBeforeLogin, 
      };
    }

    // USER ROLE REPORT ACCESS
    case types.USERROLE_REPORT_SAVED: {
      return {
        ...state,
        roleReportSaveSuccess: true,
      };
    }

    case types.USERROLE_REPORT_SAVE_FAILED: {
      return {
        ...state,
        roleReportSaveSuccess: false,
        roleReportSaveError: action.error + ' - ' + new Date().toLocaleString(),
      };
    }

    case types.USERROLE_GET_REPORT_SUCCESS: {
      let userRoleMapping = {};

      const report = LOOKUP.report;
      Object.keys(report).forEach(function (key) {
        if (report[key].isReport) {
          userRoleMapping[`roleReport-${report[key].id}`] = false;
        }
      });

      action.userRoleReport.access.map((item) => {
        userRoleMapping[`roleReport-${item.reportType}`] = item.hasAccess;
      });

      return {
        ...state,
        ...userRoleMapping,
        roleReportSaveSuccess: null,
      };
    }

    // USER ROLE PAGE ACCESS
    case types.USERROLE_PAGE_SAVED: {
      return {
        ...state,
        rolePageSaveSuccess: true,
      };
    }

    case types.USERROLE_PAGE_SAVE_FAILED: {
      return {
        ...state,
        rolePageSaveSuccess: false,
        rolePageSaveError: action.error + ' - ' + new Date().toLocaleString(),
      };
    }

    case types.USERROLE_GET_PAGE_SUCCESS: {
      const getPageOptions = () => {
        const menu = LOOKUP.menuData;

        return menu.map((item) => {
          const id = item.pageId;
          const value = id ? id.toString() : '';
          const category = item.text;
          const pages = item.items
            ? item.items
                .filter((nestedItem) => nestedItem.pageId) // Filter out items without pageId
                .map((nestedItem) => ({
                  text: nestedItem.text,
                  id: nestedItem.pageId,
                }))
            : [{ text: category, id }];
          return { id, value, category, pages };
        });
      };

      const pageList = getPageOptions();

      let userRoleMapping = {};

      (pageList || []).map((category) => {
        (category.pages || []).map((page) => {
          userRoleMapping[`rolePage-${page.id}`] = false;
        });
      });

      action.userRolePage.access.map((item) => {
        userRoleMapping[`rolePage-${item.pageCode}`] = item.hasAccess;
      });

      return {
        ...state,
        ...userRoleMapping,
        rolePageSaveSuccess: null,
      };
    }

    case types.CLEAR_INVENTORY_ADJUST: {
      let copyState = {
        ...state,
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`inventoryAdjust_`) !== -1
        ) {
          delete copyState[name];
        }
      }

      return {
        ...copyState,
        clearInventoryAdjustSuccess: new Date().toLocaleString(),
      };
    }

    case types.CLEAR_INVENTORY_AUDIT: {
      let copyState = {
        ...state,
      };

      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          name.indexOf(`InventoryAudit_`) !== -1
        ) {
          delete copyState[name];
        }
      }

      return { ...copyState };
    }

    case types.CLEAR_SCHEDULES_AND_EMPLOYEES: {
      let copyState = {
        ...state,
      };
      for (let name in copyState) {
        if (
          copyState.hasOwnProperty(name) &&
          (name.indexOf(`ScheduleAdd`) !== -1 ||
            name.indexOf(`ScheduleSend`) !== -1 ||
            name.indexOf(`scheduleView`) !== -1)
        ) {
          delete copyState[name];
        }
      }

      return { ...copyState };
    }

    case types.GET_AUDIT_SUCCESS:
    case types.AUDIT_UPDATE_SUCCESS: {
      let inventoryAudit = {};
      let copyState = {
        ...state,
      };
      action.data.products.map((item) => {
        inventoryAudit[
          `InventoryAudit_${item.id}_${item.warehouseType}_Quantity`
        ] = item.newquantity;
        inventoryAudit[
          `InventoryAudit_${item.id}_${item.warehouseType}_Notes`
        ] = item.notes;
      });
      return {
        ...copyState,
        InventoryAuditTitleName: action.data.name,
        ...inventoryAudit,
      };
    }

    case types.UPDATE_REPORT_AUTOMATION_INFO_SUCCESS:
    case types.DELETE_REPORT_AUTOMATION_SUCCESS: {
      return {
        ...state,
        reportAutomationUpdateDeleteSucess: new Date().getTime(),
      };
    }

    // ROLE
    case types.INITIALIZE_ROLE: {
      return {
        ...state,
        [`${action.compName}Name`]: null,
        [`${action.compName}IsRoleEditable`]: true,
        [`${action.compName}SaveSuccess`]: null,
        [`${action.compName}SaveError`]: null,
      };
    }
    case types.GET_ROLE_SUCCESS: {
      let claims = {};
      (action.data.claims || []).map(
        (claim) => (claims[`${action.compName}Policy-${claim.value}`] = true)
      );

      return {
        ...state,
        ...Object.keys(state)
          .filter((key) => key.includes(`${action.compName}Policy-`))
          .reduce((acc, key) => {
            acc[key] = false;
            return acc;
          }, {}),
        ...claims,
        [`${action.compName}IsRoleEditable`]: action.data.role.storeId
          ? true
          : false,
        [`${action.compName}Name`]: action.data.role.label,
        [`${action.compName}SaveSuccess`]: null,
        [`${action.compName}SaveError`]: null,
      };
    }
    case types.GET_ROLE_ERROR: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveError`]: action.error,
      };
    }
    case types.SAVE_ROLE_SUCCESS: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: true,
        [`${action.compName}SaveError`]: null,
      };
    }
    case types.SAVE_ROLE_FAILED: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveError`]: action.error,
      };
    }
    case types.UPDATE_ROLE_SUCCESS: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: true,
        [`${action.compName}SaveError`]: null,
      };
    }
    case types.UPDATE_ROLE_FAILED: {
      return {
        ...state,
        [`${action.compName}SaveSuccess`]: false,
        [`${action.compName}SaveError`]: action.error,
      };
    }

    //DELIVERY ZONE SETTING
    case types.CREATE_DELIVERY_ZONE_SUCCESS: {
      return {
        ...state,
        deliveryZoneCreateSuccessTime: new Date().getTime(),
      };
    }

    case types.UPDATE_REPORT_AUTOMATION_INFO_FAILED: {
      return {
        ...state,
        reportAutomationUpdateFailed: new Date().getTime(),
      };
    }

    case types.DELETE_REPORT_AUTOMATION_FAILED: {
      return {
        ...state,
        reportAutomationDeleteFailed: new Date().getTime(),
      };
    }

    case types.SEND_REPORT_AUTOMATION_SUCCESS: {
      return {
        ...state,
        reportAutomationSubmitSuccessTime: new Date().getTime(),
      };
    }

    case types.SEND_REPORT_AUTOMATION_FAILED: {
      return {
        ...state,
        reportAutomationSubmitFailedTime: new Date().getTime(),
      };
    }
    case types.CREATE_DELIVERY_ZONE_FAIL: {
      return {
        ...state,
        deliveryZoneCreateFailTime: new Date().getTime(),
        deliveryZoneCreateFailmsg: action.errors,
      };
    }

    case types.GET_DELIVERY_ZONE_SUCCESS: {
      return {
        ...state,
        deliveryZoneList: action.data,
      };
    }

    case types.DELETE_DELIVERY_ZONE_SUCCESS: {
      return {
        ...state,
        deliveryZoneDeleteSuccessTime: new Date().getTime(),
      };
    }

    case types.DELETE_DELIVERY_ZONE_FAIL: {
      return {
        ...state,
        deliveryZoneDeleteFailTime: new Date().getTime(),
        deliveryZoneDeleteFailmsg: action.errors,
      };
    }

    case types.UPDATE_DELIVERY_ZONE_SUCCESS: {
      return {
        ...state,
        deliveryZoneUpdateSuccessTime: new Date().getTime(),
      };
    }

    case types.UPDATE_DELIVERY_ZONE_FAIL: {
      return {
        ...state,
        deliveryZoneUpdateFailTime: new Date().getTime(),
        deliveryZoneUpdateFailmsg: action.errors,
      };
    }
    case types.INIT_STORE_RULES_FORM: {
      let copyState = {
        ...state,
        [`${action.compName}Status`]: true,
        [`${action.compName}Name`]: null,
      };

      return { ...copyState };
    }

    default:
      return state;
  }
}
